import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { AXAGOAL_LOAD_FAIL } from '../modules/team-challenge/actions/teamChallengeAction';
import { getLanguage } from '../selectors/userSelectors';

let t: i18next.TFunction;

export default () =>
  i18next
    .use(LanguageDetector)
    .init({
      resources: {
        en: {
          translations: {
            SPACE: ' ',
            FULL_STOP: '.',
            CONTACT_US: 'CONTACT US',
            CALL_CUSTOMER_SUPPORT: 'CALL CUSTOMER SUPPORT',
            TOP_NAV_GO: 'GO ',
            BACK: 'BACK',
            TO: 'TO',
            LOGOUT: 'LOGOUT',
            WELCOME_TITLE: 'Welcome to Emma by AXA',
            WELCOME_LOGIN: 'LOGIN',
            WELCOME_REGISTER: 'REGISTER',
            WELCOME_VERSION: 'VERSION',
            HOME_LABEL: 'Home',
            SETTING_LABEL: 'Settings',
            REGION_HONG_KONG: 'Hong Kong',
            REGION_MACAU: 'Macau',
            HOMEPAGE_INSURANCE_SERVICE: 'Insurance Services',
            HOMEPAGE_SEE_ALL_SERVICE: 'See All Services',
            HOMEPAGE_SEE_LESS_SERVICE: 'See Less Services',
            HOMEPAGE_SEE_ALL: 'See All',
            HOMEPAGE_SEE_LESS: 'See Less',
            HOMEPAGE_PARTNER_SERVICE:
              "<span style='font-weight: bold;'><span style='color: #494DF4;'>AXA Better</span><span style='color: #FF1721;'>Me</span></span><span style='color: #333;'> Services</span></span>",
            HOMEPAGE_PARTNER_SERVICE_MORE:
              '......many more partners coming soon',
            HOMEPAGE_HEALTH_NEWS_TITLE: 'News',
            HOMEPAGE_AXA_NEWS_TITLE: 'AXA News and Promotions',
            HOMEPAGE_SHOW_ALL_NEWS: 'See All News',
            HOMEPAGE_PROMOTION_TITLE: 'AXA New Products & Promotions',
            CHATBOT_LABEL: 'chat',
            PRELOGIN_SLIDE_TITLE_ONE: 'Ask Emma',
            PRELOGIN_SLIDE_TITLE_TWO: 'Your Privileges',
            PRELOGIN_SLIDE_TITLE_THREE: 'Insurance Services',
            PRELOGIN_SLIDE_TEXT_ONE:
              'One-click chat experience where you can engage with a service chatbot or connect with our live customer service team',
            PRELOGIN_SLIDE_TEXT_TWO:
              'Explore a wide range of all-rounded health & wellbeing services and our special offers',
            PRELOGIN_SLIDE_TEXT_THREE:
              'Access key insurance services to manage your policy, make a claim and find a health professional anytime',
            PRELOGIN_LOGIN_TEXT:
              'If you are an existing <b>MyAXA</b> user, please use <b>the same email / mobile number and password</b> to login.',
            PRELOGIN_ALL_IN_ONE_TITLE: 'Your insurance and wellness companion!',
            PRELOGIN_ALL_IN_ONE_WELCOME:
              'Access to insurance and wellness services, and stayed tuned to exciting offers and events, all in a single mobile app!',
            MY_AGENT_TITLE: 'My Agent',
            CHAT_TITLE: 'Ask Emma',
            FOOTER_POLICY_LABEL: 'Policy',
            FOOTER_PRIVACY_LABEL: 'Privacy',
            FOOTER_COPTYRIGHT_LABEL_1: 'Copyright ©',
            FOOTER_COPTYRIGHT_LABEL_2: 'AXA Hong Kong. All rights reserved.',
            FOOTER_GO_BACK_AXA_WEB: 'Go back to axa.com.hk',
            FOOTER_CONTACT_US: 'Contact Us',
            FOOTER_LANGUAGE: 'LANGUAGE: ',
            GOOD_MORNING: 'Good morning',
            GOOD_AFTERNOON: 'Good afternoon',
            GOOD_EVENING: 'Good evening',
            CWP_CUSTOMER_WELCOME_TEXT: 'Welcome to Emma by AXA',
            POLICY_LIST_LABEL: 'Policy List',
            POLICY_LIST_TITLE: 'My Policy',
            POLICY_LIST_SUBTITLE: 'Please select your policy:',
            POLICY_LIST_EB_TITLE: 'Employee Benefits',
            POLICY_LIST_IH_TITLE: 'Individual Health & Protection',
            POLICY_LIST_LI_TITLE: 'Life Insurance & Savings',
            POLICY_LIST_IL_TITLE: 'Investment Linked Insurance',
            POLICY_LIST_LAPSED_TITLE: 'Matured / Inactive Policy(s)',
            POLICY_LIST_PN: 'PN:',
            POLICY_LIST_CN: 'CN:',
            POLICY_LIST_REMARK_TITLE:
              'All of your policies with riders have been shown as below, and the icons are representing different riders:',
            POLICY_LIST_REMARK_SAVING: '- Saving',
            POLICY_LIST_REMARK_HEALTH: '- Health',
            POLICY_LIST_REMARK_INVESTMENT: '- Investment',
            POLICY_LIST_BOTTOM_REMARK: `If any policy is missing in the above of list, please call our <b>Emma Hotline: (852) 2802 2812/(853) 8799 2812</b>`,
            POLICY_LIST_BOTTOM_REMARK_LHK: `If any policy is missing in the above of list, please call our <b>Emma Hotline: (852) 2802 2812</b>`,
            POLICY_LIST_BOTTOM_REMARK_LMA: `If any policy is missing in the above of list, please call our <b>Emma Hotline: (853) 8799 2812</b>`,
            POLICY_LIST_BOTTOM_REMARK_LIFE:
              'An insured who is not the policy owner can only review Life and Individual Health Policies.',
            POLICY_LIST_BOTTOM_REMARK_LIST:
              'If any policy is missing in the above of list, please call following hotlines:',
            POLICY_LIST_RIDER_TITLE: `Riders:`,
            POLICY_LIST_ERROR_TITLE: 'System Currently Unavailable',
            POLICY_LIST_ERROR_DESCRIPTION:
              'Sorry our system is currently unavailable, please try again later.\n' +
              'For enquiries, please contact our Customer Service Hotline. (Ref. code Error 002)',
            POLICY_LIST_EMPTY_TITLE: 'Function Not Applicable',
            POLICY_LIST_EMPTY_DESCRIPTION:
              'Sorry, you do not have any policy that can use this function. Please enjoy the other features on Emma by AXA App.\n' +
              'For enquiries, please contact our Customer Service Hotline. (Ref. code Function 001)',
            AXA_GOAL_REMARK_LINE1: `Your AXA Goal membership year will be ended on the`,
            AXA_GOAL_REMARK_LINE1_42_DAYS: ` 42 days `,
            AXA_GOAL_REMARK_LINE1_42_DAYS_AFTER_TEXT: `prior to the policy anniversary of WiseGuard Pro.`,
            AXA_GOAL_REMARK_LINE2: `For the enquiries on Achieved Days and membership year, please contact our `,
            AXA_GOAL_REMARK_LINE2_CUSTOMER_SERVICE_HOTLINE: `Customer Service Hotline`,
            AXA_GOAL_REMARK_LINE2_CUSTOMER_SERVICE_HOTLINE_ON: ` on `,
            AXA_GOAL_REMARK_LINE2_CUSTOMER_SERVICE_HOTLINE_NUMBER: `(852) 2802 2812`,
            AXA_GOAL_REMARK_LINE2_CUSTOMER_SERVICE_HOTLINE_NUMBER_FULL_STOP: `.`,
            AXA_GOAL_REMARK_LINE3_CLICK_TEXT: `Click`,
            AXA_GOAL_REMARK_LINE3_HERE_TEXT: ` HERE `,
            AXA_GOAL_REMARK_LINE3_LINK: `https://www.axa.com.hk/en/axa-goal-support`,
            AXA_GOAL_REMARK_LINE3_LINK_AFTER_TEXT: `to read more about the AXA Goal information.`,

            // Densely Modal Messages - Start
            DENSELY_TITLE: `Sorry, you cannot access this feature.`,
            DENSELY_LIBRARY_TITLE: `You are going to be redirected to an external website.`,
            DENSELY_WELLNESS_COMPANION_TITLE: `You are going to be redirected to an external website.`,
            DENSELY_STRESS_TITLE: `You are going to be redirected to an external website.`,
            DENSELY_WELLNESS_COMPANION_CONTENT: `<h2>What does it mean</h2><p>&nbsp;</p><p>You are now leaving EMMA by AXA and entering a platform operated by a third party service provider, AXA People Protector Services (not by AXA Hong Kong) .</p><p>&nbsp;</p><p>Wellness Companion is a wellness management platform that helps you track and manage your physical well being.<p>&nbsp;</p><p>Click "OK" to move forward.</p>`,
            DENSELY_LIBRARY_CONTENT: `<h2>What does it mean</h2><p>&nbsp;</p><p>You are now accessing content powered by Sensely, a service provider of AXA, featuring content from the Mayo Clinic Health Library (the &ldquo;Content&rdquo;).</p><p>&nbsp;</p><p>Please note that you have accepted and are compliant with the following disclaimer and instructions if you have agreed to access or consume the content:</p><p>&nbsp;</p><p>1. The purpose of the Content is to provide general information only for users who are interested in Health Library related information. It shall not be regarded as medical advice, diagnosis, treatment or services to you or anyone else and should not be construed as such. Only registered medical practitioners can provide diagnosis and prescribe medical treatment your symptoms or conditions, or any other individual&rsquo;s symptoms or conditions.</p><p>&nbsp;</p><p>2. The information provided by the Content does not take into account of any particular facts or circumstances. Bear this in mind and apply common sense as to whether you, or any other individual, need further medical advice before taking any action after reviewing the Content. Also keep in mind that there are still risks of taking over-the-counter medicine (e.g., some medicine can interact with other medicine, food or drinks; some people are allergic to some medicine; some medicine are not safe during pregnancy). Be careful when giving medicine to children. Make sure you follow the instructions on the drug label and if you don&rsquo;t understand the instructions, ask your healthcare provider.</p><p>&nbsp;</p><p>3. We do not warrant or represent the completeness and accuracy of the information provided by the Content in any circumstances and especially in relation to your symptoms or conditions, or any other individual&rsquo;s symptoms or conditions. By using the Content, you acknowledge the limitations of the Content as mentioned in the AXA terms and conditions and that you will not rely on the information provided by the Content without obtaining further independent medical advice from a registered medical practitioner, or professional healthcare provider.</p><p>&nbsp;</p><p>4. You, and any other individual, must not use the information provided by the Content as a reason to (a) disregard the medical advice from, or (b) not to consult, any registered medical practitioner or professional healthcare provider, or as reason not to contact the emergency services.</p><p>&nbsp;</p><p>5. You, and any other individual, must not rely on the information provided by the Content as any form of alteration or alternative to medical advice from any registered medical practitioner or professional healthcare provider.</p><p>&nbsp;</p><p>6. If you, or any individual, have questions about any medical matter, symptom or condition, you should consult a registered medical practitioner or other professional healthcare providers. If it is an emergency, you or any individual must contact the emergency services immediately.</p><p>&nbsp;</p><p>To the extent permitted by law, AXA, AXA Hong Kong, Mayo Clinic and Sensely each disclaim any liability for loss, damage, costs or other expenses which you may incur as a result of failure to adhere to the foregoing.</p><p>&nbsp;</p><p>Click [I Agree] to proceed</p>`,
            DENSELY_STRESS_CONTENT: `<h2>What does it mean</h2><p>&nbsp;</p><p>You are now leaving Emma by AXA and entering a website operated by a third party service provider, Jockey Club TourHeart Project.</p><p>&nbsp;</p><p>Jockey Club TourHeart Project is a mental wellbeing programme organised by the Chinese University of Hong Kong and New Life Psychiatric Rehabilitation Association, co-organised by StoryTaler. The programme is funded by donation from the Hong Kong Jockey Club Charities Trust.</p><p>Click "OK" to move forward</p>`,
            DENSELY_STRESS_JC_CONTENT: `<p>Jockey Club TourHeart</p><p>&nbsp;</p><p>One-stop platform for promoting mental health and reducing stigma.</p><p>&nbsp;</p><p>Funded by The Hong Kong Jockey Club Charities Trust, the Jockey Club TourHeart Project is a 3-year mental health promotion and anti-stigma project that spans from September 2017 to August 2020. It strives to promote mental health in the community through evidence-based interventions with the help of modern technology. The project aims to build the one-stop online psychological self-help platform in Hong Kong with the use of a stepped care model to achieve the following goals:</p><ol><li>Raise mental health awareness and reduce stigma</li><li>Promote mental health and personal growth</li><li>Prevent depression and anxiety</li><li>Provide early intervention to psychological distress</li></ol><p>The Jockey Club TourHeart Project has no affiliation with AXA.</p>`,
            DENSELY_FIND_MY_POLICY_CONTENT: `<h2>How can I access it?</h2><p>&nbsp;</p><p>This feature is available to policyholders only. If you are a policyholder, please add your policy(s) to this account under “Find My Policy”. If you do not have a policy now, why not consider getting one?</p>`,
            DENSELY_BUTTON_I_AGREE: `I Agree`,
            DENSELY_BUTTON_OK: `OK`,
            DENSELY_BUTTON_FIND_MY_POLICY: `FIND MY POLICY`,
            // Densely Modal Messages - End

            AXA_GOAL_TITLE: 'AXA Goal',
            MY_WELLNESS_TITLE: 'My Wellness',
            CALL_CENTRE_TITLE: 'Call Centre',
            CALL_CENTRE_FAX: 'Fax: ',
            CALL_CENTRE_OPERATING_HOURS: 'Operating Hours: ',
            CALL_CENTRE_OUR_BUSINESS_ADDRESS: 'Our business address: ',
            CALL_CENTRE_SEND_AND_EMAIL: 'SEND AN EMAIL',
            VIEW_LEAFLET: 'View Leaflet',
            ENJOYAPP_TITLE: 'Emma by AXA App is now available!',
            ENJOYAPP_CONTENT:
              'Download Emma by AXA to further enjoy insurance and partner services.',
            DAY: 'day',
            MONTH: 'Month',
            ACHIEVED_DAYS: 'Total Achieved Days',
            ACHIEVED_DAYS2: 'Achieved Day(s)',
            POLICT_YEAR: 'Policy year',
            MEMBERSHIP_YEAR: ' membership year',
            ACHIEVEMENTSUMMARYTITLE: 'Achievement Summary',
            CAMPAIGN_YEAR: 'Campaign Year',
            CURRENT_CAMPAIGN_YEAR: 'Current Campaign Year',
            PREVIOUS_CAMPAIGN_YEAR: 'Previous Campaign Year',
            CAMPAIGN_PERIOD: 'Campaign Period',
            MEMBERSHIP_END_DAY: 'End date of the membership year:',
            MEMBERSHIP_YEAR_END_DATE: 'Membership year end date:',
            ARCHEVED: 'You have achieved',
            DAYS: 'day(s)',
            DAYS2: 'Achieved Days',
            ACHIEVEMENT_SUMMARY_REMARK:
              '10,000 steps or more per day is considered as an Achieved Day.',
            ACHIEVEMENT_SUMMARY_REMARK1: '* Remarks',
            ACHIEVEMENT_SUMMARY_REMARK2:
              'You are entitled to the <b>First Year Bonus</b> for participating in AXA Goal at anytime <b>within the First Membership Year</b> as defined in the AXA Goal Terms and Conditions. <br/><br/>Please refer to the AXA Goal Terms and Condition for more details.',
            ACHIEVEMENT_SUMMARY_REMARK3: 'only.',
            SH_ACHIEVEMENT_SUMMARY_REMARK:
              '10,000 steps or more per day is considered as an Achieved Day.',
            SH_ACHIEVEMENT_SUMMARY_REMARK1: '* Remarks',
            SH_ACHIEVEMENT_SUMMARY_REMARK2:
              '*+50 Achieved Days : You are entitled to the First Year Bonus for participating in AXA Goal at anytime within the First Membership Year as defined in the AXA Goal Terms and Conditions.',
            SH_ACHIEVEMENT_SUMMARY_REMARK3: '',
            ACHIEVEMENT_SUMMARY_REMARK_EARLY_BIRD:
              'You are entitled to the <b>Early Bird Bonus</b> for participating in AXA Goal during the period from 26 July to 27 August 2019. <br/><br/>Please refer to the AXA Goal Terms and Condition for more details.',
            ACHIEVEMENT_SUMMARY_EARLY_BIRD_BONUS:
              '（including Early Bird Bonus : ${nBonusDays} days*）',
            ACHIEVEMENT_SUMMARY_FIRST_YEAR_BONUS:
              '（including First Year Bonus : ${nBonusDays} days*）',
            ACHIEVEMENT_SUMMARY_SHOW_MORE_MONTHS: 'Show More Months',
            ACHIEVEMENT_SUMMARY_SHOW_LESS_MONTHS: 'Show Less Months',
            CHANGE_TRACKER: 'Tracking device',
            NEWBIE: 'Challenger',
            NEWBIE_ACHIEVED: 'Challenger',
            CRYSTAL: 'Crystal',
            JADE: 'Jade',
            DIAMOND: 'Diamond',
            YOUR_NEXT_LEVEL: 'Your next level',
            YOUR_ULTIMATE_LEVEL: 'Your ultimate goal',
            NEWBIE_CONTENT: 'New AXA Goal user with less than 50 achieved days',
            SH_NEWBIE_CONTENT:
              '125 Achieved Days/ membership year to get 10% premium rebate',
            RULE_MEMBERSHIP_YEAR: 'AXA Goal Membership Year',
            SH_RULE_MEMBERSHIP_YEAR: 'AXA Goal (Lite) Membership Year',
            RULE_MEMBERSHIP_CONTENT:
              'AXA Goal will record the number of steps based on the membership period to calculate the premium rebate.',
            SH_RULE_MEMBERSHIP_CONTENT:
              'AXA Goal (Lite) membership year is the time period for recording steps to calculate the premium rebate.',
            CRYSTAL_CONTENT_DAYS: '50 Achieved Days',
            CRYSTAL_CONTENT_DISCOUNT: 'to get 5% premium rebate',
            JADE_CONTENT_DAYS: '125 Achieved Days',
            JADE_CONTENT_DISCOUNT: 'to get 10% premium rebate',
            DIAMOND_CONTENT_DAYS: '250 Achieved Days',
            DIAMOND_CONTENT_DISCOUNT: 'to get 20% premium rebate',
            MAKE_STEP_CHALLENGE_FUN_TITLE:
              'How to make the step challenge fun?',
            MAKE_STEP_CHALLENGE_FUN_CONTENT:
              'Join the fun-themed weekly step challenges offered by Wellness Companion by clicking the button below. All steps accumulated therein will also be considered when determining the number of Achieved Days in that membership year.',
            START_NOW: 'Start Now',
            RULES_AND_REGULATIONS: 'AXA Goal Rules',
            SH_RULES_AND_REGULATIONS: 'AXA Goal (Lite) Rules',
            RULES_AND_REGULATIONS_TITLE:
              'Get up to a 20% premium rebate when you get moving',
            SH_RULES_AND_REGULATIONS_TITLE:
              'How to enjoy premium rebate when you get moving?',
            RULES_TAB_AXA_GOAL: 'AXA Goal',
            RULES_TAB_AXA_GOAL_LITE: 'AXA Goal (Lite)',
            RULES_TITLE: '10, 000 steps = 1 Achieved Days',
            SH_RULES_TITLE: '10,000 steps = 1 Achieved Days',
            STEP_COUNT_PERIOD: 'AXA Goal step count period',
            STARTED_IS_EASY:
              'Getting started in AXA Goal is easy – link a tracking device with your registered Emma by AXA account via the Emma setting page to start tracking your steps.<br><br>For each day you take 10,000 steps or more, you will achieve an Achieved Day. Obtain a certain number of Achieved Days within the membership year to earn a premium rebate.<br><br>Please refer to the relevant leaflet for details.',
            SH_STARTED_IS_EASY:
              'Getting started in AXA Goal (Lite) is easy – link a tracking device with your registered Emma by AXA account via the Emma setting page to start tracking your steps.<br><br>For each day you take 10,000 steps or more, you will achieve an Achieved Day. Obtain a certain number of Achieved Days per membership year to earn a premium rebate.<br><br>Please refer to the relevant leaflet for details.',
            PARTICIPATED_THI_CAMPAIGN: '',
            ACHIEVEMENT_SUMMARY_MODAL_TITLE: 'First Year Bonus',
            ACHIEVEMENT_SUMMARY_MODAL_TITLE2: 'Early Bird Bonus',
            ACHIEVEMENT_SUMMARY_MODAL_CONTENT1:
              '*+50 Achieved Days : You are entitled to the First Year Bonus for participating in AXA Goal at anytime within the First Membership Year as defined in the AXA Goal Terms and Conditions.',
            ACHIEVEMENT_SUMMARY_MODAL_CONTENT2:
              '*+75 Achieved Days: You are entitled to the Early Bird Bonus for participating in AXA Goal during the period from 26 July to 27 August 2019.',
            ACHIEVEMENT_SUMMARY_MODAL_BTN: 'OK',
            ACHIEVEMENT_SUMMARY_PREMIUM_REBATE: 'Premium Rebate',
            PREMIUM_REBATE_MODAL_TITLE: 'AXA Goal - Premium Level',
            SH_PREMIUM_REBATE_MODAL_TITLE: 'AXA Goal (Lite) - Premium Level',
            PREMIUM_REBATE_MODAL_OK_BTN: 'OK',

            //Settings
            SETTINGS_MY_INFO: 'My Information',
            SETTINGS_LET_US_HELP: 'Let us help you',
            SETTINGS_SUPPORT_BUTTON: 'Support',
            SETTINGS_MACAU_LIFE: 'For Macau Policy only',
            SETTINGS_ANNUITY_AND_ACCUMULATION_RATES:
              'Interest Rate on Death Proceeds by Instalments/',
            SETTINGS_ANNUITY_AND_ACCUMULATION_RATES_TWO:
              'Accumulation Interest Rate',
            SETTINGS_ABOUT_EMMA: 'About Emma by AXA',
            SETTINGS_TERMS_AND_CONDITIONS: 'Terms & Conditions',
            SETTINGS_PRIVACY_POLICY: 'Privacy Policy & Data Usage',
            SETTING_SECURITY_AWARENESS: 'Anti-Scam Tips',
            CLOSE: 'Close',
            VHIS_MODAL_TITLE: 'Welcome',
            VHIS_MODAL_SUBTITLE: 'Annual Step Challenge',
            VHIS_MODAL_CONTENT:
              'Join our 10,000 steps a day annual challenge<br/>to earn a premium rebate on your next policy<br/>renewal.',
            MY_WELLNESS_MODAL_CONTENT:
              'Challenge yourself to a healthier lifestyle with My Wellness!',
            VHIS_MODAL_BTN: 'Download Emma by AXA',
            VHIS_MODAL_LINK: 'AXA Goal Rules',
            MY_WELLNESS_MODAL_LINK: 'MY WELLNESS RULES',
            VHIS_DOWNLOAD: 'DOWNLOAD',

            //TNC Modal
            TNC_MODAL_TITLE: 'Terms & Conditions',
            TNC_MODAL_TNC_1: 'I/we acknowledge and agree with the ',
            TNC_MODAL_TNC_2: ' Emma by AXA Terms & Conditions',
            TNC_MODAL_TNC_3: '.',
            TNC_MODAL_TNC_ERROR: 'Mandatory to tick ',
            TNC_MODAL_MARKETING:
              'I/ we consent to the use of my/ our personal data for direct marketing purposes by AXA in accordance with the PICS  (optional).',
            TNC_MODAL_PIC_1: 'I/ we acknowledge and agree with the ',
            TNC_MODAL_PIC_2:
              'Emma by AXA Privacy Policy and Personal Information Collection Statement',
            TNC_MODAL_PIC_3: ' (PICS).',
            TNC_MODAL_PIC_ERROR: 'Mandatory to tick',
            TNC_MODAL_PIPL_1:
              'I/ we consent to the processing of my/ our sensitive personal data by AXA, and that of minors under my/ our guardianship (if applicable).',
            TNC_MODAL_PIPL_2:
              'I/ we consent to the provision of my/ our personal data to appointed processors and their partners within Mainland China.',
            TNC_MODAL_PIPL_3:
              'I/ we consent to the provision of my/ our personal data to appointed processors and their partners outside of Mainland China.',
            TNC_MODAL_PIPL_ERROR_1: 'Mandatory to tick',
            TNC_MODAL_PIPL_ERROR_2: 'Mandatory to tick',
            TNC_MODAL_PIPL_ERROR_3: 'Mandatory to tick',
            TNC_MODAL_OK: 'Accept',
            TNC_MODAL_CLOSE: 'Close',

            // EMMA BANNER
            EMMA_BANNER_OK: 'OK',
            EMMA_BANNER_CLOSE: 'Close',

            //EMMA AXA GOAL TEAM CHALLENGE
            TEAM_CHALLENGE_RULES_AND_REGULATIONS: 'Team Challenge Rules',
            TEAM_CHALLENGE_RULES_MORE_HITS_MORE_FUN_TITLE:
              'More HITs, More Fun!',
            TEAM_CHALLENGE_RULES_AIMS:
              'Want to have fun, keep fit and earn rewards all in one go? Simply form a team with your colleagues and compete with the others in your company on the no. of HITs!​',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_POINTS_TITLE: 'How do I get HITs?',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_POINTS_CONTENT_P1:
              '10,000 steps in a day = 1 HIT!',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_POINTS_CONTENT_P2:
              'This in turn gives you 5 Fitpoints, which can be used to redeem rewards on Wellness Companion.',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_TITLE:
              'How do I get started?',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_1: 'Create/Join a Team',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_1_DESC:
              'Create or join a team with team size between 4 to 8 colleagues​',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_2:
              'Link Your Tracking Device',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_3: 'Join the Challenge',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_3_DESC:
              'Once you’ve formed your team, join challenge with a simple click. Any member can join on behalf of the team',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_4: 'Get Moving!​',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_4_DESC:
              'Make sure you step up daily starting on the official start date, your steps are now being counted',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_5:
              'View Your Team’s Ranking',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_5_DESC:
              'You can view it anytime in the Team Challenge section of Wellness Companion',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_6:
              'Complete the Challenge',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_6_DESC:
              'Your company will announce the winning team!',
            TEAM_CHALLENGE_RULES_BTN_CREATE_TEAM: 'CREATE TEAM',
            TEAM_CHALLENGE_RULES_BTN_GOT_INVITATION: 'JOIN TEAM',
            TEAM_CHALLENGE_RULES_FOOTER_TITLE: 'Important Note',
            TEAM_CHALLENGE_RULES_FOOTER_CONTENT:
              'If you have multiple health tracking devices linked to Emma, only the single highest daily step count will be considered for this challenge',

            // Marketplace
            HOMEPAGE_MARKETPLACE_SEE_ALL_SERVICE: 'See All',
            MYPRIVILEGES_LABEL: 'My Privileges',
            // MANNING
            MANNING_HEALTH_COLLABORATION: 'Mannings Health Collaboration',
            MANNING_APPOINTMENT_SELECTED_POLICY: '*Select Policy',
            MANNING_APPOINTMENT_SELECTED_POLICY_PLACEHOLDER: 'Select Policy',
            MANNING_APPOINTMENT_INSURED_NAME: '*Insured Name',
            MANNING_APPOINTMENT_INSURED_NAME_PLACEHOLDER: 'Select Insured Name',
            MANNING_APPOINTMENT_SELECT_A_MANNING_STORE:
              '*Select Mannings Store',
            MANNING_APPOINTMENT_MANNING_STORE_PLACEHOLDER:
              'Select Mannings Store',
            MANNING_APPOINTMENT_PREFERRED_DATE: '*Preferred Date',
            MANNING_APPOINTMENT_PREFERRED_TIME: '*Preferred Time',
            MANNING_APPOINTMENT_CLOSED: 'Closed',
            MANNING_APPOINTMENT_PREFERRED_TIME_PLACEHOLDER: 'Select Time',
            MANNING_APPOINTMENT_CONTACT_EMAIL: '*Insured Email',
            MANNING_APPOINTMENT_MOBILE_NO: '*Insured Mobile Number',
            MANNING_APPOINTMENT_CONFIRM_BOOKING: 'REQUEST MY BOOKING',
            MANNING_APPOINTMENT_DIALOG_BUTTON_CANCEL: 'Cancel',
            MANNING_APPOINTMENT_DIALOG_BUTTON_TRY_AGAIN: 'Try Again',
            MANNING_APPOINTMENT_SUCCESS_TITLE:
              'Success! Your booking request has been submitted!',
            MANNING_APPOINTMENT_SUCCESS_SUB_TITLE:
              'Your booking has been submitted.',
            MANNING_APPOINTMENT_SUCCESS_STEP_TITLE: 'Booking steps:',
            MANNING_APPOINTMENT_SUCCESS_STEP1_DES:
              '1. Mannings will call you to confirm your booking within 1-2 working days',
            MANNING_APPOINTMENT_SUCCESS_STEP2_DES:
              '2. Bring your reservation email with your identity document on your appointment day',
            MANNING_APPOINTMENT_SUCCESS_STEP3_DES:
              '3. Enjoy the health check-up',
            MANNING_APPOINTMENT_DATE: 'Preferred date:',
            MANNING_APPOINTMENT_BOOKING_NAME: 'Booking name:',
            MANNING_APPOINTMENT_POLICY_NUMBER: 'Policy number:',
            MANNING_APPOINTMENT_EREQUEST_NUMBER: 'eRequest number:',
            MANNING_APPOINTMENT_LOCATION: 'Mannings store address:',
            MANNING_APPOINTMENT_TIME: 'Preferred time:',
            MANNING_APPOINTMENT_TEL: 'Mannings store phone number:',
            MANNING_APPOINTMENT_DEAR: 'Dear Valued Customer',
            MANNING_APPOINTMENT_REQUESTED_DESC:
              'A separate appointment email of your request will be sent to you within 24-hour as a record.',
            MANNING_EMAIL_ERROR_MSG: 'Incorrect email format',
            MANNING_MOBILE_ERROR_MSG: 'Incorrect mobile format',
            MANNING_APPOINTMENT_SUBMIT_ERROR_TITLE: 'Opps...',
            MANNING_APPOINTMENT_SUBMIT_ERROR_MSG:
              'We are sorry that an error has occured. Please try again.',
            MANNING_APPOINTMENT_REQUIRED_FIELDS: '*Required Fields',
            MEMBERSHIP_PERIOD: 'Membership period:',
            COMMON_MEMBERSHIP_YEAR: ' Membership year',
            CURRENT_MEMBERSHIP_YEAR: 'Current membership year',
            PREVIOUS_MEMBERSHIP_YEAR: 'Previous membership year',
            MANNING_APPOINTMENT_SELECT_ADVANCE:
              'Select a date up to 3 weeks in advance',
            MANNING_APPOINTMENT_GOT_IT: 'GOT IT',
            WORDS: 'words',
            MIN: 'min',
            CONNECT: 'CONNECT',
            HELP_APP_TITLE: 'We’re here to help.',
            HELP_APP_PHONE_NUMBER: '(852) 2802 2812',
            HELP_APP_WEB_SITE: 'https://www.axa.com.hk/en/axa-goal-support',
            // FANCL
            FANCL_HEALTH_COLLABORATION: 'Skin & Health Consultation',
            FANCL_APPOINTMENT_SELECTED_POLICY: '*Select Policy',
            FANCL_APPOINTMENT_SELECTED_POLICY_PLACEHOLDER: 'Select Policy',
            FANCL_APPOINTMENT_SELECTED_POLICY_NOT_APPLICABLE: 'Not Applicable',
            FANCL_APPOINTMENT_SELECT_GENDER: '*Select Gender',
            FANCL_APPOINTMENT_GENDER_PLACEHOLDER: 'Select Gender',
            FANCL_APPOINTMENT_GENDER_MALE: 'Male',
            FANCL_APPOINTMENT_GENDER_FEMALE: 'Female',
            FANCL_APPOINTMENT_GENDER_PREFER_NOT_TO_DISCLOSE:
              'Prefer not to disclose',
            FANCL_APPOINTMENT_NAME: '*English Full Name',
            FANCL_APPOINTMENT_SELECT_A_FANCL_STORE: '*Select FANCL Store',
            FANCL_APPOINTMENT_FANCL_STORE_PLACEHOLDER: 'Select FANCL Store',
            FANCL_APPOINTMENT_PREFERRED_DATE: '*Preferred Date',
            FANCL_APPOINTMENT_PREFERRED_TIME: '*Preferred Time',
            FANCL_APPOINTMENT_CLOSED: 'Closed',
            FANCL_APPOINTMENT_PREFERRED_TIME_PLACEHOLDER: 'Select Time',
            FANCL_APPOINTMENT_CONTACT_EMAIL: '*Email',
            FANCL_APPOINTMENT_MOBILE_NO: '*Mobile Number',
            FANCL_APPOINTMENT_CONFIRM_BOOKING: 'OK, I WISH TO PROCEED',
            FANCL_APPOINTMENT_DIALOG_BUTTON_CANCEL: 'Cancel',
            FANCL_APPOINTMENT_DIALOG_BUTTON_TRY_AGAIN: 'Try Again',
            FANCL_APPOINTMENT_SUCCESS_TITLE:
              'Success! Your booking request has been submitted!',
            FANCL_APPOINTMENT_SUCCESS_SUB_TITLE:
              'Your booking has been submitted.',
            FANCL_APPOINTMENT_SUCCESS_STEP_TITLE: 'Booking steps:',
            FANCL_APPOINTMENT_SUCCESS_STEP1_DES:
              '1. FANCL will contact you within 2 working days via WhatsApp/ phone to confirm your booking',
            FANCL_APPOINTMENT_SUCCESS_STEP2_DES:
              '2. Bring your appointment email on your appointment day',
            FANCL_APPOINTMENT_SUCCESS_STEP3_DES:
              '3. Enjoy the consultation at the selected FANCL store',
            FANCL_APPOINTMENT_DATE: 'Preferred date:',
            FANCL_APPOINTMENT_BOOKING_NAME: 'Booking name:',
            FANCL_APPOINTMENT_POLICY_NUMBER: 'Policy number:',
            FANCL_APPOINTMENT_EREQUEST_NUMBER: 'eRequest number:',
            FANCL_APPOINTMENT_GENDER: 'Gender:',
            FANCL_APPOINTMENT_LOCATION: 'FANCL store address:',
            FANCL_APPOINTMENT_TIME: 'Preferred time:',
            FANCL_APPOINTMENT_DEAR: 'Dear Valued Customer',
            FANCL_APPOINTMENT_REQUESTED_DESC:
              'A separate appointment email of your request will be sent to you within 24-hour as a record.',
            FANCL_APPOINTMENT_REMINDER:
              '#Under the influence of pandemic, the opening hours of FANCL store may vary. FANCL will contact you to confirm the booking time.',
            FANCL_EMAIL_ERROR_MSG: 'Incorrect email format',
            FANCL_MOBILE_ERROR_MSG: 'Incorrect mobile format',
            FANCL_NAME_ERROR_MSG: 'Incorrect name format',
            FANCL_APPOINTMENT_SUBMIT_ERROR_TITLE: 'Opps...',
            FANCL_APPOINTMENT_SUBMIT_ERROR_MSG:
              'We are sorry that an error has occured. Please try again.',
            FANCL_APPOINTMENT_REQUIRED_FIELDS: '*Required Fields',
            FANCL_APPOINTMENT_SELECT_ADVANCE:
              'Select a date from 2 working days later up to 3 weeks',
            FANCL_APPOINTMENT_GOT_IT: 'GOT IT',
            // Woman Product
            WOMEN_PRODUCT_BENEFIT_COVERAGE: 'Benefit Coverage',
            WOMEN_PRODUCT_POLICY_LABEL: 'Plan name',
            WOMEN_PRODUCT_POLICY_TIPS:
              '*This Benefit Schedule is subject to and shall be read together with the provisions of this policy.',
            PRIVILEGES_CATEGORY_TITLE: 'What privileges could I enjoy?',
            WOMEN_PRODUCT_EXPLORE_MORE: 'EXPLORE MORE',
            WOMANPRODUCT_ENQUIRY: 'Enquiry',
            WOMEN_PRODUCT_ENQUIRY_DESC1: 'If you have any enquiries, please ​',
            WOMEN_PRODUCT_ENQUIRY_DESC2: 'contact us.',
            WOMEN_PRODUCT_BENEFIT_ITEMS: 'Benefit Items',
            WOMEN_PRODUCT_MAKE_A_APOINTMENT: 'MAKE AN APPOINTMENT',
            WOMEN_PRODUCT_KEY_EXCULSIONS: 'Key Exclusions',
            WOMEN_PRODUCT_PRODUCT_BROCHURE: 'PRODUCT BROCHURE',
            WOMEN_PRODUCT_REMARKS: 'Remarks',
            WOMEN_PRODUCT_MAKE_APPOINTMENT_TITLE:
              'Select a designated service provider to book an appointment',
            WOMEN_PRODUCT_MAKE_APPOINTMENT_SUB_TITLE:
              "Selecting 'Book Now' will connect you to a third-party service provider's hotline for appointments.",
            WOMEN_PRODUCT_REMAINING_VISIT_TIME_LABEL:
              'Remaining visit per policy year',
            WOMEN_PRODUCT_CHECK_COVERAGE_REMARK: 'Product Remarks',
            WOMEN_PRODUCT_DOWNLOAD_DOCUMENT: 'Download%20Documents',
            WOMEN_PRODUCT_RESERVATION_BTN_TEXT: 'Book Now',

            // Membership Tutorial
            MEMBERSHIP_NEXT: 'NEXT',
            MEMBERSHIP_CLOSE: 'CLOSE',

            // Error Modal
            ERROR_MODAL_TITLE: 'Service Temporarily Unavailable',
            ERROR_MODAL_MESSAGE:
              'Something went wrong, please try again later, If this persists, please contact us for further assistance.',
            ERROR_MODAL_BUTTON_CANCEL: 'CANCEL',
            ERROR_MODAL_BUTTON_OK: 'OK',
            ERROR_MODAL_BUTTON_TRY_AGAIN: 'TRY AGAIN',
            SELECT_YOUR_ELIGIBLE_POLICY: 'Select your eligible policy:',
            SELECT_YOUR_ELIGIBLE_POLICY_DESC:
              'Please take note of the membership period of each policy as your achieved days count could be affected.',
            WELCOME_TO_AXA_GOAL: 'Welcome to AXA Goal',
            NEXT: 'OK, I WISH TO PROCEED',
            EMPTY_DATE_FIELD: 'Date Field cannot be empty',
            EMPTY_MONTH_FIELD: 'Month Field cannot be empty',
            EMPTY_YEAR_FIELD: 'Year Field cannot be empty',
            DATE_INVALID: 'Invalid Date',
            BIRTHDATE_LOW_THAN_6_MONTH:
              'Family member must be aged between 6 months old to 80 years old',
            BIRTHDATE_LOW_THAN_18: 'User must be 18 years old or older',
            BIRTHDATE_MORE_THAN_65:
              'Free protection is only applicable for customers 65 years old or below',
            BIRTHDATE_MORE_THAN_80:
              'Free protection is only applicable for customers 80 years old or below',
            OFFERS_FORM_POLICY_MODAL_HEADER:
              'AXA “Post-Vaccination Protection” Programme Terms and Conditions',
            OFFERS_FORM_POLICY_MODAL_DETAILS:
              '1.\tAXA “Post-Vaccination Protection” Programme (“Programme”) is offered by AXA China Region Insurance Company (Bermuda) Limited (Incorporated in Bermuda with limited liability) (“AXA”), subject to the following relevant terms and conditions. <br><br>' +
              '2.\tThe registration period for the Programme starts from 30th November 2020 on a first-come-first-serve basis and is subject to availability (“Registration Period”).<br><br>' +
              '<b><u>Eligibility of Applicant(s)</u></b><br><br>' +
              '3.\tAll Hong Kong / Macau Special Administrative Region (“Hong Kong” or “Macau” respectively) residents are eligible applicants for the Programme (“Eligible Applicant”). The Eligible Applicant must hold a valid Hong Kong identity card or Macau identity card; and be aged 18 or above but below the age of 65 at the registration date.<br><br>' +
              '4.\tAn Eligible Applicant may register on behalf of up to four immediate family members (“Eligible Family Member”) for the Programme during the Registration Period. The Eligible Family Member must be a spouse or child of the Eligible Applicant; hold a valid Hong Kong identity card or Macau identity card; and be aged 65 or below at the registration date. The Eligible Applicant understands that this Programme is not applicable for persons outside of Hong Kong or Macau.<br><br>' +
              '5.\tWithin the Registration Period, if the Eligible Applicant has successfully installed the “Emma by AXA” mobile application and has registered for the Programme, a confirmation email will be sent to the Eligible Applicant with a registration number and the Programme protection benefit details. The Eligible Applicant must receive the email mentioned above for the Programme protection benefits to be effective.<br><br>' +
              '<b><u>Eligibility of Vaccination(s)</u></b><br><br>' +
              '6.\tThe vaccination, including the first dose, subsequent doses and booster doses must be approved by the United States Food and Drug Administration or local health authorities and prescribed by a Registered Medical Practitioner in Hong Kong or Macau in any public Hospital, private Hospital or registered medical practitioner clinic. For the avoidance of doubt, vaccinations performed at offsite locations in Hong Kong or Macau, but with the prescription of a Registered Medical Practitioner, are also accepted. <br><br>' +
              '7.\tAccording to the World Health Organization, Adverse Event Following Immunization (AEFI) has the following meanings: <br><br>' +
              '•\tAny untoward medical occurrence which follows Immunisation and which does not necessarily have a causal relationship with the usage of the vaccine. The adverse event may be any unfavorable or unintended sign, abnormal laboratory finding, symptom or disease.<br><br>' +
              '•\tThere are five categories of AEFI: vaccine product-related reaction, vaccine quality defect-related reaction, Immunisation error-related reaction, Immunisation anxiety-related reaction and coincidental event.<br><br>' +
              '•\tThe adverse reactions can further be classified as allergic reactions, local reactions such as redness, pain, swelling at inject site; systematic reaction like fever, sepsis, rash, fatigue etc; and neurological disorders include seizures, encephalopathy, meningitis, encephalitis, brachial neuritis and Guillain-Barre Syndrome.<br><br>' +
              '<b><u>Definitions of Registered Medical Practitioner and Hospital</u></b><br><br>' +
              '8.\tRegistered Medical Practitioner shall mean a medical practitioner of western medicine, <br><br>' +
              '(a) who is duly qualified and is registered with the Medical Council of Hong Kong pursuant to the Medical Registration Ordinance (Cap. 161 of the Laws of Hong Kong) or a body of equivalent standing in Macau (as reasonably determined by AXA in good faith); and <br><br>' +
              '(b) legally authorised for rendering relevant medical service in Hong Kong or Macau where the medical service is provided to the Eligible Applicant and/or Eligible Family Member. If the practitioner is not duly qualified and registered under the laws of Hong Kong or a body of equivalent standing in Macau (as reasonably determined by AXA in good faith), AXA shall exercise reasonable judgment to determine whether such practitioner shall nonetheless be considered qualified and registered.<br><br>' +
              '9.\tHospital shall mean an establishment duly constituted and registered as a hospital under the laws of Hong Kong or Macau in which it is established, which is for providing medical service for sick and injured persons as Inpatients, and which ‒ <br><br>' +
              '•\thas facilities for diagnosis and major operations; <br><br>' +
              '•\tprovides 24-hour nursing services by licensed or registered nurses; <br><br>' +
              '•\thas one or more Registered Medical Practitioners; and <br><br>' +
              '•\tis not primarily a clinic, a place for alcoholics or drug addicts, a nature care clinic, a health hydro, a nursing, rest or convalescent home, a hospice or palliative care centre, a rehabilitation centre, an elderly home or similar establishment. <br><br>' +
              '<b><u>Programme Protection Benefits</u></b><br><br>' +
              '10.\tThe protection benefits of the Programme cover hospitalisation or death as a result of an AEFI within 14 days after receiving an approved vaccination within one year starting from the registration date (“Programme Protection Period”). <br><br>' +
              '11.\tHospital benefit is available to admission of the Eligible Applicant and/or Eligible Family Member to a Hospital that is recommended by a Registered Medical Practitioner for medical service and as an Inpatient as a result of a medically necessary condition for a period of no less than six (6) consecutive hours. No minimum period is required for confinement in connection with any emergency treatment in a Hospital as a result of an emergency for the performance of a surgical procedure or other medical service in a Hospital. Confinement shall be evidenced by a daily room charge invoiced by the Hospital and the Eligible Applicant and/or Eligible Family Member must stay in the Hospital continuously for the entire period of confinement.<br><br>' +
              '12.\tDeath benefit is available if the Eligible Applicant and/or Eligible Family Member dies due to an AEFI during the Programme Protection Period.<br><br>' +
              '13.\tIf an Eligible Applicant and/or the Eligible Family Member during the Programme Protection Period: <br><br>' +
              '(i) is diagnosed with an AEFI within 14 days and is confined in a hospital, the hospital benefit of HKD700 per day for a period of up to 10 days payable under this Programme will be paid to the Eligible Applicant; and/or<br><br>' +
              '(ii) is diagnosed with an AEFI within 14 days and its complications result in death, AXA shall pay out a one-off lump sum death benefit of HKD100,000 to Eligible Applicant’s estate. <br><br>' +
              '14.\tEach Eligible Applicant and/or Eligible Family Member is entitled to a maximum of 10 days’ hospital benefit during the Programme Protection Period and/or one death benefit at maximum.<br><br>' +
              '15.\tThe Eligible Applicant and/or Eligible Family Member will not be eligible for the hospital benefit and/or the death benefit if an AEFI occurs after the Programme Protection Period.<br><br>' +
              '16.\tAny payment(s) associated with this Programme will be subject to applicable laws and AXA’s standard screening procedures to be conducted at the time of claim.<br><br>' +
              '<b><u>Exclusions</u></b><br><br>' +
              '17.\tAXA will not pay any hospital benefit and/or death benefit for any hospitalisation or death of the Eligible Applicant and/or Eligible Family Member that is resulting directly or indirectly from, or caused or contributed (in whole or in part) by other factors besides a vaccination, including: <br><br>' +
              '(i) any self-inflicted injury or suicide, whether sane or insane, and <br><br>' +
              '(ii) terrorist attack using any type of biochemical weapon. <br><br>' +
              '<b><u>Claims</u></b><br><br>' +
              '18.\tSupporting documents for claims submission (must be submitted within 90 days from date of consultation/treatment/death, whichever is latest): <br><br>' +
              '•\tHong Kong identity card, Macau identity card or copy of relevant identity documents; <br><br>' +
              '•\ta proof of relationship (where applicable);<br><br>' +
              '•\ta proof of diagnosis (confirming an AEFI due to an approved vaccine prescribed by Registered Medical Practitioner during the Programme Protection Period) and hospital confinement document or a legal death certificate (as the case may be);<br><br>' +
              '•\ta letter of administration granted by the Hong Kong or Macau high court on the deceased estate (for death claim).<br><br>' +
              '19.\tClaims submission method: <br><br>' +
              '(i) Download the Hospitalisation Claim Form I at www.axa.com.hk (for the hospital benefit) and/or the Death Claim Form I form at www.axa.com.hk (for the death benefit)<br><br>' +
              '(ii) Submit claim application by email using the subject “AXA Post-Vaccination Protection Programme Claim - [Registration Number]” to:<br><br>' +
              '(Hong Kong): life.claims@axa.com.hk; or <br><br>' +
              '(Macau): ma.enquiry@axa.com.mo <br><br>' +
              '20.\tClaims for Eligible Applicant and/or Eligible Family Member are expected to be submitted by the Eligible Applicant.<br><br>' +
              '<b><u>Termination</u></b><br><br>' +
              '21.\tThe above hospital benefit and death benefit will be automatically terminated once the corresponding protection period is expired. <br><br>' +
              '22.\tAXA reserves the right to alter or terminate the Programme (in whole or in part) and/or amend the relevant terms and conditions of the Programme at any time without prior notice. In case of any dispute, the decision of AXA shall be final and conclusive. <br><br>' +
              '23.\tThese term and conditions shall be governed by the laws of Hong Kong. In the event of any inconsistency and/or omission between the English language and other language versions of these terms and conditions, the English language version shall prevail.<br><br>' +
              'If you do not wish to receive promotional or direct marketing materials from AXA, please inform the Data Privacy Officer, AXA China Region Insurance Company (Bermuda) Limited (Incorporated in Bermuda with limited liability), Suite 2001, 20/F, Tower Two, Times Square, 1 Matheson Street, Causeway Bay, Hong Kong. AXA shall, without charge to you, ensure that you are not included in future direct marketing activities. <br><br>' +
              '(Only for use in Hong Kong and Macau Special Administrative Region)<br><br>',
            REVIEW_INFORMATION: 'Review Information',
            CONFIRM: 'CONFIRM',
            OFFERS_COMFIRM_SUCCESS_TITLE: 'Registration Successful!',
            OFFERS_COMFIRM_SUCCESS_MSG:
              'You have successfully registered for the “Free AXA SportsCare” Programme.  Programme details including benefit coverage and protection period will be emailed to you shortly.',
            OFFERS_COMFIRM_UNSUCCESS_TITLE: 'Registration Unsuccessful',
            OFFERS_COMFIRM_UNSUCCESS_MSG:
              'You have already registered for the "Free AXA SportsCare" Programme previously, please refer to your confirmation email for details, or contact our programme hotline at ${tel} should you have any enquiries.<br/>Tap the button below to explore more offers!',
            OFFERS_COMFIRM_SUCCESS_BUTTON_TEXT: 'EXPLORE MORE OFFERS',
            NAME_PLACEHOLDER: 'Your name',
            EMAIL_PLACEHOLDER: 'Your email address',
            DAY_PLACEHOLDER: 'DD',
            MONTH_PLACEHOLDER: 'MM',
            YEAR_PLACEHOLDER: 'YYYY',
            GENDER_PLACEHOLDER: 'Male / Female',
            GENDER_MALE_OPTION: 'Male',
            GENDER_FEMALE_OPTION: 'Female',
            MOBILE_PLACEHOLDER: 'Your mobile number',
            RELATIONSHIP_PLACEHOLDER: 'Spouse / Child / Parent / Parent-in-law',
            RELATIONSHIP_SPOUSE_OPTION: 'Spouse',
            RELATIONSHIP_CHILD_OPTION: 'Child',
            RELATIONSHIP_PARENT_OPTION: 'Parent',
            RELATIONSHIP_PARENT_IN_LAW_OPTION: 'Parent-in-law',
            BOOK_NOW: 'Book Now',

            // Login error
            LOGIN_ERROR_TITLE: 'System Currently Unavailable',
            LOGIN_ERROR_DESC:
              'Sorry our system is currently unavailable, please try again later. For enquiries, please contact our Customer Service Hotline. (Ref. code Error 003)',

            // offer lead form contact time
            MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_ANY_TIME: 'Any Time',
            MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_IN_THE_MORNING:
              'In the Morning',
            MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_LUNCH_TIME: 'Lunch Time',
            MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_IN_THE_AFTERNOON:
              'In the Afternoon',
            OFFERS_SUBMIT_LEAD_FORM_SUCCESS_TITLE: 'We will contact you soon',
            OFFERS_SUBMIT_LEAD_FORM_SUCCESS_MSG:
              'Thank you ${name} for your interest in ${productName}. Our Financial Consultant will contact you ${time}.',
            OFFERS_SUBMIT_LEAD_FORM_SUCCESS_BUTTON: 'GOT IT',
            OK_I_UNDERSTAND_AND_LETS_PROCEED: 'OK, I WISH TO PROCEED',
            NO_THANKS_BRING_ME_BACK: 'NO THANKS, BRING ME BACK',
            REVIEW_CONSULTANT_MOBILE_NO: 'Mobile No. Of Financial Consultant',
            REVIEW_PROMOTION_CODE: 'Promotional Code',
            XPAPI_MANDATORY_PROMOCODE_NOTVALID:
              'The promotional code you entered is invalid. For users without promotional code, please visit again on/ after 1 Jan 2022.',
            XPAPI_OPTIONAL_PROMOCODE_NOTVALID:
              'Please enter a valid promo code (optional).',

            // Offer tab
            UI_MY_PRIVILEGES_TAB_PRIVILEGES: 'AXA BetterMe',
            UI_MY_PRIVILEGES_TAB_OFFERS: 'Offers',
            UI_MY_PRIVILEGES_VALID_UNTIL: 'Valid until: ',
            UI_MY_PRIVILEGES_PRODUCT_TITLE: 'Popular Offers',
            UI_MY_PRIVILEGES_CAMPAIGNS_TITLE: 'Latest Campaigns',
            UI_MY_PRIVILEGES_TERMS_APPLY:
              '*Promotion terms and conditions apply',
            BIRTHDATE_LESS_THAN_CURRENT_DATE:
              'Family member must be aged between 6 months old to 80 years old',

            // Health Keeper Modal View
            HEALTH_KEEPER_MODAL_VIEW_HEADER_DESC:
              'Tap the links below and read them carefully.',
            HEALTH_KEEPER_MODAL_VIEW_HEADER_CLOSE_BUTTON: 'Close',
            HEALTH_KEEPER_MODAL_VIEW_BODY_TITLE: 'Terms and Conditions',
            HEALTH_KEEPER_MODAL_VIEW_BODY_DESC:
              'By checking the box(es), you acknowledge that you have read and agree to the following terms:',
            HEALTH_KEEPER_MODAL_VIEW_BODY_CHECK_WELLNESS: 'Wellnesss Companion',
            HEALTH_KEEPER_MODAL_VIEW_BODY_CHECK_TERMS: 'Terms and Conditions',
            HEALTH_KEEPER_MODAL_VIEW_FOOTER_BUTTON: 'I AGREE',

            //Benefit EB remark
            BENEFIT_EB_REMARK:
              'The above content is intended only to be a summary of the Benefit Coverage of the insurance plan<br/><br/>Please go to “<a class="benefit-eb-remark-font-link">Download Documents - Benefit Coverage</a>” for further details (include but not limited to Benefit Remarks, Benefit Notes e.g. Specialist Referral letter requirement)" <br/><br/>If there is any inconsistency or ambiguity between the above content and the full Employee Benefit Medical Insurance Policy Summary, the full Employee Benefit Medical Insurance Policy Summary shall prevail',
            BENEFIT_EB_REMARK_DOCUMENT_NAME:
              'Employee Benefit Medical Insurance Policy Summary',

            //Benefit Coverage(Check Coverage)
            WOMEN_PRODUCT_POLICYNO_LABEL: 'Policy no.',
            WOMEN_PRODUCT_INSUREDNAME_LABEL: 'Insured Name',
            WOMEN_PRODUCT_SHOWBENEFIT_LABEL:
              'Your Group Medical Insurance Benefits',
            WOMEN_PRODUCT_SHOWBENEFIT_REMARK:
              '*Beware the usage or amount limit on each individual benefits upon using.',
            WOMEN_PRODUCT_TAXDE_DUCTIONBANNER_TITLE:
              'Want to get more coverage?',
            WOMEN_PRODUCT_BENEFIT_DORPDOWN_ALL: 'All',
            WOMEN_PRODUCT_BENEFIT_DORPDOWN_BENEFITS: 'Benefits',

            // Customer Profile
            CUSTOMER_PROFILE: 'My Profile',
            CUSTOMER_PROFILE_CHANGE_CONTACT_TITLE:
              'Edit Policy Contact Details',
            CUSTOMER_PROFILE_CONTACT_DETAILS_TITLE: 'Update Contact Details',
            CUSTOMER_PROFILE_UPDATE_MOBILE_TITLE: 'Update Mobile',
            CUSTOMER_PROFILE_UPDATE_EMAIL_TITLE: 'Update Email',
            CUSTOMER_PROFILE_POLICY_GROUP_OPTION_LABEL:
              'Your contact details for the following General Insurance and Individual Health policies will be updated:',
            CUSTOMER_PROFILE_POLICY_GROUP_OPTION_REMARK1: 'Important notes: ',
            CUSTOMER_PROFILE_POLICY_GROUP_OPTION_REMARK2:
              'Please note that upon updating the above contact details, all other General Insurance policies (including those applied through a bank) will also be updated. For enquiry, please contact our customer service hotline.',
            CUSTOMER_PROFILE_POLICY_GROUP_OPTION_REMARK3:
              'For policies arranged through insurance intermediaries, you are advised to provide them the same update accordingly.',
            CUSTOMER_PROFILE_POLICY_OPTION_ENQUIRY:
              'For enquiries, please contact our customer service hotline.',
            CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_1:
              'After you submitted your ${progressType}, it will be updated within ${workingDay} business days, and a confirmation email/SMS will be sent to you afterwards.',
            CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_2:
              'After you submitted your ${progressType}, it will be updated within ${workingDay} business days.',
            CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_EMAIL:
              'email address update request',
            CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_MOBILE:
              'mobile number update request',
            CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_BOTH:
              'email address and mobile number update request',
            CUSTOMER_PROFILE_UPDATE_ADDRESS_TITLE:
              'Update Correspondence Address',
            CUSTOMER_PROFILE_UPDATE_ADDRESS_MAP_VIEW_TITLE: 'Search Address',
            CUSTOMER_PROFILE_UPDATE_ADDRESS_INPUT_FIELD_REQUIRED:
              'This field is required',
            CUSTOMER_PROFILE_UPDATE_ADDRESS_INPUT_FIELD_EN:
              'Only English addresses are supported',
            CUSTOMER_PROFILE_UPDATE_ADDRESS_MANDATORY: 'Mandatory field',
            CUSTOMER_PROFILE_UPDATE_ADDRESS_EXCEED_CHARACTER_LIMIT:
              'Exceeded character limit',

            // Password
            INPUT_ENTER_PASSWORD: 'Enter New Password',
            INPUT_CONFIRM_PASSWORD: 'Retype New Password',
            INPUT_EMPTY_FIELD: 'Field cannot be empty',
            INPUT_INCORRECT_FORMAT: 'Incorrect format',
            INPUT_INCORRECT_REPETITION:
              'Password cannot contain same 3 characters in a row',
            INPUT_INCORRECT_SPACE: 'Passwords cannot have Spaces',
            INPUT_INCORRECT_LOWER:
              'Password must contain lowercase character(s)',
            INPUT_INCORRECT_UPPER:
              'Password must contain uppercase character(s)',
            INPUT_INCORRECT_DIGIT: 'Password must contain digit(s)',
            INPUT_INCORRECT_SEQUENCE:
              'Password cannot contain six consecutive digits/letters.',
            INPUT_INCORRECT_SPECIAL:
              'Password must contain special character(s) ie. *&^$#$%^&*)(',
            INPUT_INCORRECT_LENGTH: 'Password must be 8 to 16 characters long',
            INPUT_INCORRECT_MATCH: 'Password does not match',

            //otp
            OTP_ENTER_CODE: 'Enter ${length}-digit verification code',
            OTP_TEXT: 'Please check your SMS and enter the verification code',
            OTP_EMAIL_TEXT:
              'Please check your Email and enter the verification code',
            OTP_DOT_NOT_GET_CODE: 'Didn’t get the code?',
            OTP_RESEND: 'Resend',

            // insure
            POLICY_LIST_INSURE_SUBTITLE:
              "Please select your policy(You're the insured):",

            //longLoading
            LONG_LOADING_TEXT:
              'Thanks for your patience.<br/>The page will be loaded soon…',

            //axa goal dashboard
            AXA_GOAL_DASHBOARD_TITLE: 'AXA Goal Dashboard',
            AXA_GOAL_DASHBOARD_WELCOME: 'Welcome to AXA Goal',
            AXA_GOAL_DASHBOARD_YOUR_POLICY: 'Your policies',
            AXA_GOAL_DASHBOARD_YOUR_AND_FAMILY_POLICY:
              "You and your insured's policies",
            AXA_GOAL_DASHBOARD_YOUR_FAMILY: "Your insured's policies",
            AXA_GOAL_DASHBOARD_SEE_ALL: 'See All ({policies})',
            AXA_GOAL_DASHBOARD_INSURED_NAME: 'Insured name',
            AXA_GOAL_DASHBOARD_END_DATE: 'Membership Year End Date',
            AXA_GOAL_DASHBOARD_ACHIEVED_DAYS: 'Achieved Days*',
            AXA_GOAL_DASHBOARD_UPDATED_WITHIN_HOURS: '*Updated within 48 hours',
            AXA_GOAL_DASHBOARD_KNOW_MORE: 'Know More',
            AXA_GOAL_DASHBOARD_BANNER_TITLE: 'Wellness Companion',
            AXA_GOAL_DASHBOARD_BANNER_TEXT: 'Make Step Challenge More Fun',
            AXA_GOAL_DASHBOARD_BANNER_BUTTON: 'KNOW MORE',
            AXA_GOAL_DASHBOARD_SUPPORT: 'SUPPORT',
            AXA_GOAL_DASHBOARD_SUPPORT_TEXT:
              'Click here if you have any questions',
            AXA_GOAL_DASHBOARD_SUPPORT_LOWERCASE: 'Support',
            AXA_GOAL_DASHBOARD_TRACKING_DEVICE: 'Tracking Device',
            AXA_GOAL_DASHBOARD_VIEW_ALL_TEXT:
              "A maximum of 5 policies are shown here, select 'VIEW ALL' to view all",
            AXA_GOAL_DASHBOARD_VIEW_ALL_BUTTON: 'VIEW ALL',
            AXA_GOAL_DASHBOARD_NO_POLICY_TEXT:
              'Sorry, no AXA Goal Policies found',

            AXA_GOAL_SCENAVIO_GRANT_ACCESS_TEXT:
              'Activate access to your over 18 years old family members for participation in AXA Goal to earn up to 20% in premium rebate',
            AXA_GOAL_SCENAVIO_GRANT_ACCESS_BUTTON_TEXT: "GO TO 'MY INSURED'",
            AXA_GOAL_SCENAVIO_REMINDER_TEXT:
              'Insured person has not yet enrolled to AXA Goal.',
            AXA_GOAL_SCENAVIO_REMINDER_BUTTON_TEXT: 'SEND REMINDER',
            AXA_GOAL_SCENAVIO_ENROLLMENT_TEXT_HK: 'Join AXA Goal today!',
            AXA_GOAL_SCENAVIO_ENROLLMENT_TEXT_MACAU: 'Join AXA Goal today!',
            AXA_GOAL_SCENAVIO_ENROLLMENT_BUTTON_TEXT: 'ENROLL NOW',
            AXA_GOAL_SCENAVIO_OVER_AGE_TEXT:
              'Please note only insured people over the age of 18 can join AXA Goal.',
            AXA_GOAL_SCENAVIO_ERROR_TEXT:
              'Oops... There is an unexpected error. You may have multiple Emma by AXA accounts. Please contact support.',
            AXA_GOAL_SCENAVIO_ERROR_BUTTON_TEXT: 'CONTACT US',

            // AXA Goal See All Policy Page
            AXA_GOAL_SEE_ALL_POLICY_TITLE: 'All Policies with AXA Goal',
            AXA_GOAL_SEE_ALL_POLICY_TITLE_MY_ACTION_REQUIRED:
              'Action required policies',
            AXA_GOAL_SEE_ALL_POLICY_TITLE_MY_POLICY: 'Your policies',
            AXA_GOAL_SEE_ALL_POLICY_TITLE_MY_FAMILY: "Your insured's policies",

            // AXA Goal Support
            AXA_GOAL_SUPPORT_TITLE: 'AXA Goal Support',
            MY_WELLNESS_SUPPORT_TITLE: 'Wellness Buddy Support',
            AXA_GOAL_SUPPORT_QUESTION: 'Frequently Asked Questions',
            AXA_GOAL_SUPPORT_RULES: 'AXA Goal Rules',
            MY_WELLNESS_SUPPORT_RULES: 'Wellness Buddy Rules',
            AXA_GOAL_SUPPORT_TRACKING_DEVICE:
              'How to connect your tracking device',
            AXA_GOAL_SUPPORT_ACHIEVED_DAYS: 'Missing Achieved Days',
            AXA_GOAL_SUPPORT_HELP_YOU: 'Let us help you',
            AXA_GOAL_SUPPORT_HELP: 'Questions? We’re here to help.',
            AXA_GOAL_SUPPORT_HELP_TEXT:
              'Contact your policy agent from My Policy(s) or our Customer Service Centre.',
            AXA_GOAL_SUPPORT_CONTACT_AGENT: 'Contact your agent',

            // AXA Goal record
            AXA_GOAL_RECORD_TITLE: 'Record',
            AXA_GOAL_RECORD_PROBLEM: 'Questions regarding your Achieved Days?',
            AXA_GOAL_RECORD_SUPPORT: 'GET SUPPORT',
            AXA_GOAL_RECORD_ACHIEVED_DAY: 'Achieved day (10,000+ steps)',
            AXA_GOAL_RECORD_NON_ACHIEVED_DAY:
              'Non-Achieved Day (below 10,000 steps)',
            SH_AXA_GOAL_RECORD_ACHIEVED_DAY: 'Achieved Day (10,000+ steps)',
            SH_AXA_GOAL_RECORD_NON_ACHIEVED_DAY:
              'Non-Achieved Day (below 10,000 steps)',
            AXA_GOAL_RECORD_DATA_PROCESSING_DAY:
              'Data processing (will be ready within 48hrs)',
            AXA_GOAL_RECORD_START_DAY: 'Membership year start day',
            AXA_GOAL_RECORD_END_DAY: 'Membership year end day',
            AXA_GOAL_RECORD_START: 'Start',
            AXA_GOAL_RECORD_END: 'End',
            AXA_GOAL_RECORD_HEAD_TITLE: 'achieved day(s)',

            //CountryTelephoneNumber
            COUNTRY_TELEPHONE_NUMBER_DROPDOWN_PLACEHOLDER: 'Select',

            //aktivo-health-survey
            AKTIVO_HEALTH_SURVEY_TITLE: 'Health Survey',
            AKTIVO_HEALTH_SURVEY_HOME_TITLE: 'Set up your health profile',
            AKTIVO_HEALTH_SURVEY_HOME_CONTENT:
              'Tell us a bit more, so we can provide you with more personalized health insights',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_TITLE:
              'We would like to know the information below:',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_GENDER: 'Gender',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_DOB: 'Date of Birth',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_HEIGHT: 'Height',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_WEIGHT: 'Weight',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_SLEEP: 'Sleeping Pattern',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_DAILY: 'Daily Habits',
            AKTIVO_HEALTH_SURVEY_GENDER_TITLE: 'Your Gender',
            AKTIVO_HEALTH_SURVEY_GENDER_MALE: 'Male',
            AKTIVO_HEALTH_SURVEY_GENDER_FEMALE: 'Female',
            AKTIVO_HEALTH_SURVEY_DOB_TITLE: '	Your Birthday',
            AKTIVO_HEALTH_SURVEY_DOB: 'Date of Birth',
            AKTIVO_HEALTH_SURVEY_TALL_TITLE: 'Your Height',
            AKTIVO_HEALTH_SURVEY_WEIGHT_TITLE: 'Your Weight',
            AKTIVO_HEALTH_SURVEY_SLEEPING_TITLE: 'Your Sleeping Pattern',
            AKTIVO_HEALTH_SURVEY_SMOKE_TITLE: 'Your Smoking Habit',
            AKTIVO_HEALTH_SURVEY_DRINK_TITLE: 'Your Drinking Habit',
            AKTIVO_HEALTH_SURVEY_CONTINUE: 'NEXT',
            AKTIVO_HEALTH_SURVEY_FINISH_THE_SURVEY: 'SUBMIT SURVEY',
            AKTIVO_HEALTH_SURVEY_LAUNCH_MY_WELLNESS: 'START',
            AKTIVO_HEALTH_SURVEY_END_THANK_YOU: 'Survey Completed',
            AKTIVO_HEALTH_SURVEY_END_TEXT_1:
              'Personalized health insights will be provided based on your survey response.',
            AKTIVO_HEALTH_SURVEY_END_TEXT_2:
              "Let's start using Wellness Buddy and build a healthier lifestyle!",
            AKTIVO_HEALTH_SURVEY_BED_TIME: 'Bedtime',
            AKTIVO_HEALTH_SURVEY_WAKE_UP_TIME: 'Wake-up time',
            AKTIVO_HEALTH_SURVEY_SMOKE_QUESTION:
              'How many cigarettes on average do you smoke per day?',
            AKTIVO_HEALTH_SURVEY_DRINK_QUESTION:
              'How many alcoholic drinks on average do you drink per week?',
            AKTIVO_HEALTH_SURVEY_PREFER_NOT_TO_ANSWER: 'Prefer not to answer',
            AKTIVO_HEALTH_SURVEY_LBS: 'lbs',
            AKTIVO_HEALTH_SURVEY_KG: 'kg',
            AKTIVO_HEALTH_SURVEY_CM: 'cm',

            //dropdown common title
            DROPDOWN_COMMON_TITLE: 'Select',
            // enter password
            ENTERPASSWORD_NAV_TITLE: 'Delete Account',
            ENTERPASSWORD_TITLE: 'We are sorry to see you go.',
            ENTERPASSWORD_SUB_TITLE:
              'Before you proceed with deleting your Emma by AXA account, please note that:',
            ENTERPASSWORD_SUB_DESC:
              '1.If you have any of, but not limited to, the following data on our/third parties’ system, they will not be deleted together with your account, but will no longer be available to you through Emma.  These will be retained and handled according to the ${pics}.',
            ENTERPASSWORD_SUB_DESC_PICS:
              'Personal Information Collection Statement',
            ENTERPASSWORD_SECTION_ONE:
              'AXA Goal step count record – to be stored in our database, for the purpose of calculating your premium rebates, until 7 years after all your AXA Goal eligible policies lapsed',
            ENTERPASSWORD_SECTION_TWO:
              'Wellness companion/My Wellness challenge data',
            ENTERPASSWORD_SECTION_THREE:
              'Dr Go subscription – to be stored on eSmartHealth Limited’s database, so that you can continue using your subscribed services, until 7 years after your subscription expired',
            ENTERPASSWORD_DESC_ONE:
              '2.If you subscribed to Dr Go’s service, you will no longer be able to access it via Emma, You may visit Dr Go’s mobile application or website to continue enjoying your subscription, by logging in with the corresponding username and password of your Dr Go account.',
            ENTERPASSWORD_DESC_TWO:
              '3.You may register for a new Emma by AXA account reusing your current username 24 hours after it has been successfully deleted.  If you are an AXA Goal user, only the step count accumulated before current account deletion or after new account registration, whichever is higher, will be used for premium rebate calculation purpose.',
            ENTERPASSWORD_DESC_THREE:
              'Should you require any assistance, please contact our customer service hotline at ',
            ENTERPASSWORD_DESC_THREE_TEL: '(852) 2802 2812.',
            ENTERPASSWORD_NEXT_BUTTON: 'CONFIRM DELETION',
            ENTERPASSWORD_CONFIRMATION_TITLE: 'Sorry to see you go!',
            ENTERPASSWORD_CONFIRMATION_SUB_TITLE:
              'Wish we could serve you again!',
            ENTERPASSWORD_CONFIRMATION_STEP_ONE_TITLE: 'Goodbye here',
            ENTERPASSWORD_CONFIRMATION_STEP_TWO_TITLE:
              'You can reuse your username for creating another new account after a few days.',
            ENTERPASSWORD_CONFIRMATION_LOGOUT: 'logout',
            // aktivo individual challenge
            AKTIVO_INDIVIDUAL_CHALLENGE_APPLY: 'APPLY',
            AKTIVO_INDIVIDUAL_CHALLENGE_FILTER: 'Filter',
            AKTIVO_INDIVIDUAL_CHALLENGE_SORTING: 'Sorting',
            AKTIVO_INDIVIDUAL_CHALLENGE_CATEGORY: 'Category',
            AKTIVO_INDIVIDUAL_CHALLENGE_CHALLENGE_TYPE: 'Challenge type',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_PERIOD: 'Time Period',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_LATEST_TO_OLDEST:
              'Latest to Oldest',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_OLDEST_TO_LATEST:
              'Oldest to Latest',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_START_MOVING_TODAY:
              'Start moving today',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_LEARN_MORE: 'LEARN MORE',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_ONGOING: 'Ongoing',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_READY_TO_ENROLL: 'Ready to enroll',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_OVER: 'Over',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_YOUR_PROGRESS: 'Your Progress',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_STEPS: 'Steps',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_COMPLETED: 'Completed',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_COMING_SOON: 'Coming Soon',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_CHALLENGE_DETAILS:
              'Challenge Details',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_ENROLL_NOW: 'ENROLL NOW',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_COMPLETED_CHALLENGE:
              'Completed Challenge',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_CHALLENGE_TITLE: 'My Challenges',
            AKTIVO_INDIVIDUAL_CHALLENGE_HEALTH_INSIGHTS_TITLE: 'Health Insight',
            AKTIVO_INDIVIDUAL_CHALLENGE_HEALTH_INSIGHTS_ERROR_MSG_TITLE_PART1:
              'Sync failed, please check your internet connection and',
            AKTIVO_INDIVIDUAL_CHALLENGE_HEALTH_INSIGHTS_ERROR_MSG_TITLE_PART2:
              'try reload again.',
            AKTIVO_INDIVIDUAL_CHALLENGE_HEALTH_INSIGHTS_OUR_SUGGESTION_TITLE:
              'Our suggestion',
            AKTIVO_INDIVIDUAL_CHALLENGE_ALL_ENROLLED_TITLE: 'Well Done!',
            AKTIVO_INDIVIDUAL_CHALLENGE_ALL_ENROLLED_SUB_TITLE:
              'There are no new challenges available for enrollment',
            AKTIVO_INDIVIDUAL_CHALLENGE_ALL_NO_ENROLLED_TIP: 'Step',
            AKTIVO_INDIVIDUAL_CHALLENGE_ALL_NO_ENROLLED_TITLE:
              'Achieve 100,000 a week',
            AKTIVO_INDIVIDUAL_CHALLENGE_ALL_NO_ENROLLED_SUB_TITLE:
              'You have not enrolled in any challenges or your currently enrolled challenges have not ended yet ',
            AKTIVO_INDIVIDUAL_CHALLENGE_ALL_NO_ENROLLED_BUTTON: 'ENROLL NOW',
            AKTIVO_INDIVIDUAL_CHALLENGE_START: 'Start',
            LOGIN_PRIVACY_POLICY: 'Privacy Policy',
            LOGIN_TERMS_AND_CONDITIONS: 'Terms and Conditions',
            LOGIN_PRIVACY_AND: ' and ',
          },
        },
        zh: {
          translations: {
            SPACE: '',
            FULL_STOP: '。',
            CONTACT_US: '聯絡我們',
            CALL_CUSTOMER_SUPPORT: '致電客戶服務中心',
            TOP_NAV_GO: '',
            BACK: '返回',
            TO: '',
            LOGOUT: '登出',
            WELCOME_TITLE: 'Emma by AXA 歡迎您！',
            WELCOME_LOGIN: '登入',
            WELCOME_REGISTER: '註冊',
            WELCOME_VERSION: '版本',
            HOME_LABEL: '主頁',
            SETTING_LABEL: '設定',
            REGION_HONG_KONG: '香港',
            REGION_MACAU: '澳門',
            HOMEPAGE_INSURANCE_SERVICE: '保險服務',
            HOMEPAGE_SEE_ALL_SERVICE: '查看全部',
            HOMEPAGE_SEE_LESS_SERVICE: '查看部分',
            HOMEPAGE_SEE_ALL: '查看全部',
            HOMEPAGE_SEE_LESS: '查看部分',
            HOMEPAGE_PARTNER_SERVICE:
              "<span style='font-weight: bold;'><span style='color: #494DF4;'>AXA Better</span><span style='color: #FF1721;'>Me</span></span><span style='color: #333;'> 服務</span>",
            HOMEPAGE_PARTNER_SERVICE_MORE: '......即將推出更多夥伴服務',
            HOMEPAGE_HEALTH_NEWS_TITLE: '資訊',
            HOMEPAGE_AXA_NEWS_TITLE: 'AXA安盛資訊及推廣',
            HOMEPAGE_SHOW_ALL_NEWS: '顯示更多',
            HOMEPAGE_PROMOTION_TITLE: 'AXA 安盛 推廣活動',
            CHATBOT_LABEL: 'chat ZH',
            PRELOGIN_SLIDE_TITLE_ONE: '與Emma對話',
            PRELOGIN_SLIDE_TITLE_TWO: '您的貼心禮遇',
            PRELOGIN_SLIDE_TITLE_THREE: '查閱主要保險服務',
            PRELOGIN_SLIDE_TEXT_ONE:
              '與Chatbot或在線客戶服務團隊直接查詢及對話，享受一鍵式聊天體驗。',
            PRELOGIN_SLIDE_TEXT_TWO: '盡享一系列身心支援服務及獨家優惠',
            PRELOGIN_SLIDE_TEXT_THREE:
              '歡迎使用我們的保險服務，隨時隨地管理您的保單，提出索償，或尋找健康專員。',
            PRELOGIN_LOGIN_TEXT:
              '如您是<b>MyAXA</b>用戶，您可以使用相同的<b>電郵/流動電話號碼及密碼登入。</b>',
            PRELOGIN_ALL_IN_ONE_TITLE: '您的保險及健康夥伴！',
            PRELOGIN_ALL_IN_ONE_WELCOME:
              '一個手機應用程式，有齊保險及身心支援服務，更為您提供各項精彩禮遇及活動！',
            MY_AGENT_TITLE: 'My Agent ZH',
            CHAT_TITLE: '與Emma對話',
            FOOTER_POLICY_LABEL: 'Policy ZH',
            FOOTER_PRIVACY_LABEL: 'Privacy ZH',
            FOOTER_COPTYRIGHT_LABEL_1: '版權 ©',
            FOOTER_COPTYRIGHT_LABEL_2: 'AXA安盛香港。版權所有。',
            FOOTER_GO_BACK_AXA_WEB: 'Go back to axa.com.hk ZH',
            FOOTER_CONTACT_US: '聯絡我們',
            FOOTER_LANGUAGE: '語言: ',
            GOOD_MORNING: '早晨',
            GOOD_AFTERNOON: '午安',
            GOOD_EVENING: '晚安',
            CWP_CUSTOMER_WELCOME_TEXT: '歡迎來到Emma by AXA！',

            POLICY_LIST_LABEL: 'Policy List',
            POLICY_LIST_TITLE: '我的保單',
            POLICY_LIST_SUBTITLE: '請選擇您的保單:',
            POLICY_LIST_EB_TITLE: '僱員福利保單',
            POLICY_LIST_IH_TITLE: '個人保障',
            POLICY_LIST_LI_TITLE: '人壽保障及儲蓄',
            POLICY_LIST_IL_TITLE: '投資連繫式壽險',
            POLICY_LIST_LAPSED_TITLE: '期滿 / 失效保單',
            POLICY_LIST_PN: 'PN:',
            POLICY_LIST_CN: 'CN:',
            POLICY_LIST_REMARK_TITLE:
              'All of your policies with riders have been shown as below, and the icons are representing different riders:',
            POLICY_LIST_REMARK_SAVING: '- Saving',
            POLICY_LIST_REMARK_HEALTH: '- Health',
            POLICY_LIST_REMARK_INVESTMENT: '- Investment',
            POLICY_LIST_BOTTOM_REMARK: `如果有任何保單未能顯示於上述列表中，請致電我們的 <b>Emma 熱線: (852) 2802 2812/(853) 8799 2812</b>`,
            POLICY_LIST_BOTTOM_REMARK_LHK: `如果有任何保單未能顯示於上述列表中，請致電我們的 <b>Emma 熱線: (852) 2802 2812</b>`,
            POLICY_LIST_BOTTOM_REMARK_LMA: `如果有任何保單未能顯示於上述列表中，請致電我們的 <b>Emma 熱線: (853) 8799 2812</b>`,
            POLICY_LIST_BOTTOM_REMARK_LIFE:
              '如受保人非保單持有人，則只能查看人壽及個人保障保單。',
            POLICY_LIST_BOTTOM_REMARK_LIST:
              '如果有任何保單未能顯示於上述列表中，請致電以下熱線: ',
            POLICY_LIST_RIDER_TITLE: `附加契約:`,
            POLICY_LIST_ERROR_TITLE: '系統暫時無法使用',
            POLICY_LIST_ERROR_DESCRIPTION:
              '抱歉，系統暫時無法使用，請稍後再試。\n' +
              '如有查詢，請聯絡AXA客戶服務熱線。（參考編號Error 002）',
            POLICY_LIST_EMPTY_TITLE: '功能不適用',
            POLICY_LIST_EMPTY_DESCRIPTION:
              '抱歉，您沒有可以使用此功能的保單，歡迎使用Emma by AXA 應用程式上的其他功能。\n' +
              '如有查詢，請聯絡AXA安盛客戶服務熱線。 (參考編號Function 001)',
            AXA_GOAL_REMARK_LINE1: `您的AXA Goal會籍年度會於「智尊守慧」保單周年日前的`,
            AXA_GOAL_REMARK_LINE1_42_DAYS: `42日`,
            AXA_GOAL_REMARK_LINE1_42_DAYS_AFTER_TEXT: `終止。`,
            AXA_GOAL_REMARK_LINE2: `如對達標日數和會籍年度有疑問，請致電我們的`,
            AXA_GOAL_REMARK_LINE2_CUSTOMER_SERVICE_HOTLINE: `客戶熱線`,
            AXA_GOAL_REMARK_LINE2_CUSTOMER_SERVICE_HOTLINE_ON: ``,
            AXA_GOAL_REMARK_LINE2_CUSTOMER_SERVICE_HOTLINE_NUMBER: `(852) 2802 2812`,
            AXA_GOAL_REMARK_LINE2_CUSTOMER_SERVICE_HOTLINE_NUMBER_FULL_STOP: `。`,
            AXA_GOAL_REMARK_LINE3_CLICK_TEXT: `點擊`,
            AXA_GOAL_REMARK_LINE3_HERE_TEXT: `此處`,
            AXA_GOAL_REMARK_LINE3_LINK: `https://www.axa.com.hk/zh/axa-goal-support`,
            AXA_GOAL_REMARK_LINE3_LINK_AFTER_TEXT: `瀏覽更多有關AXA Goal的資訊。`,

            // Densely Modal Messages - Start
            DENSELY_TITLE: `對不起，您未能使用這項服務。`,
            DENSELY_LIBRARY_TITLE: `您將會被連結到另一網站`,
            DENSELY_WELLNESS_COMPANION_TITLE: `您將會被連結到另一網站`,
            DENSELY_STRESS_TITLE: `您將會被連結到另一網站`,
            DENSELY_WELLNESS_COMPANION_CONTENT: `<h2>這代表甚麼</h2><p>&nbsp;</p><p>您現正離開Emma by AXA並進入第三方服務提供者 AXA People Protector Services 營運的平台 (並非由AXA安盛營運)。</p><p>&nbsp;</p><p>健康拍檔 是一個健康管理平台，幫助您記錄和管理您的健康狀況。</p><p>&nbsp;</p><p>點擊 "OK" 繼續前往</p>`,
            DENSELY_LIBRARY_CONTENT: `<h2>這代表甚麼</h2><p>&nbsp;</p><p>您現正讀取由AXA安盛服務提供者Sensely所提供的內容，當中包含來自健康百科的內容（&ldquo;內容&rdquo;）。</p><p>&nbsp;</p><p>請注意，若您同意讀取或使用內容，則表示您已接受及遵守以下免責聲明和指引：</p><p>&nbsp;</p><p>1. 內容的目的是只為對自我護理相關資訊感興趣的用戶提供一般資訊。內容不應被視為對您或任何其他人的醫療建議、診斷、治療或服務，及不應該被解釋如上述意思。只有註冊醫生才能為您的症狀或狀況，或任何其他人士的症狀或狀況提供診斷和處方。</p><p>&nbsp;</p><p>2. 內容所提供的資訊未考慮任何特定實況或情況。請緊記此點並在閱讀內容後採取任何行動前，以常識判斷您或任何其他人士是否需要進一步的醫療建議。同時亦請謹記，服用非處方藥物仍然存在風險（例如，某些藥物可能與其他藥物、食物或飲料互相影響；有些人對某些藥物過敏；有些藥物在懷孕期間使用不安全）。讓兒童服藥時須謹慎小心。請您確保遵循藥物標籤上的指示及如有不明白的地方，敬請向您的醫護服務提供者查詢。</p><p>&nbsp;</p><p>3. 我們不會保證或陳述內容所提供的資訊在任何情況之下的完整性和準確性，尤其與您相關的症狀或狀況，或與任何其他人士相關的症狀或狀況。當您使用內容時，您知悉於AXA安盛條款及條件中提及的內容的限制，並且不會在未向註冊醫生或專業醫護服務提供者獲得進一步的獨立醫療建議下依賴內容所提供的資訊。</p><p>&nbsp;</p><p>4. 您和任何其他人士不得以內容所提供的資訊為理由，而(a）無視任何註冊醫生或專業醫護服務提供者的醫療建議，或(b）不諮詢任何註冊醫生或專業醫護服務提供者的意見，或作為不聯繫緊急服務的理由。</p><p>&nbsp;</p><p>5. 您及任何其他人士不得依賴內容所提供的資訊而以任何形式更改或代替任何註冊醫生或專業醫護服務提供者的醫療建議。</p><p>&nbsp;</p><p>6. 如果您或任何人士對任何醫療事宜、症狀或狀況有任何疑問，您應諮詢註冊醫生或其他專業醫護服務提供者。如有緊急情況，您或任何人士必須即時聯絡緊急服務。</p><p>&nbsp;</p><p>在法律允許的範圍內，AXA安盛、AXA安盛香港、Mayo Clinic及Sensely均不承擔任何您可能因未遵守上述規定而招致的損失、損害、費用或其他費用的責任。</p><p>&nbsp;</p><p>點擊 "我同意" 繼續前往</p>`,
            DENSELY_STRESS_CONTENT: `<h2>這代表甚麼</h2><p>&nbsp;</p><p>您現正離開Emma by AXA, 並進入第三方服務提供者 賽馬會心導遊計劃營運的網站。</p><p>&nbsp;</p><p>賽馬會心導遊計劃是由香港中文大學和新生精神康復會合辦，說書人協辦的精神健康計劃。該計劃由香港賽馬會慈善信託基金贊助。</p><p>&nbsp;</p><p>點擊 "OK" 繼續前往</p>`,
            DENSELY_STRESS_JC_CONTENT: `<p>賽馬會心導遊計劃</p><p>&nbsp;</p><p>一站式網上平台，旨在推廣心理健康，減少對精神病患者的誤解。</p><p>&nbsp;</p><p>計劃由香港賽馬會慈善信託基金資助，以促進精神健康及及反歧視為目的。計劃項目為期3年，2017年9月起展開，直至2020年8月。運用現代科技以實證為本的方法，致力促進社區的心理健康。此項目旨透過建立一站式網上心理支援平台，以及探用階梯支援模式，以實踐以下目標：</p><p>提高公眾對心理健康的意識及去除公眾對病精神病的誤解<br /> 推動心理健康及個人成長<br /> 預防抑鬱症及焦慮症<br /> 及早處理情緒困擾</p><p>本計劃與AXA 安盛沒有任何關係。</p>`,
            DENSELY_FIND_MY_POLICY_CONTENT: `<h2>如何才能使用這些服務？</h2><p>&nbsp;</p><p>這些服務唯保單持有人尊享。如果您是保單持有人，請在「搜尋我的保單」中將保單加到您的賬戶內。還未是保單持有人？何不考慮投保為自己買份保障?</p>`,
            DENSELY_BUTTON_I_AGREE: `我同意`,
            DENSELY_BUTTON_OK: `OK`,
            DENSELY_BUTTON_FIND_MY_POLICY: `搜尋我的保單`,
            // Densely Modal Messages - End
            AXA_GOAL_TITLE: 'AXA Goal',
            MY_WELLNESS_TITLE: '健康拍檔',
            CALL_CENTRE_TITLE: '客戶服務中心',
            CALL_CENTRE_FAX: '傳真: ',
            CALL_CENTRE_OPERATING_HOURS: '營業時間: ',
            CALL_CENTRE_OUR_BUSINESS_ADDRESS: '營業地址: ',
            CALL_CENTRE_SEND_AND_EMAIL: '電郵查詢',
            VIEW_LEAFLET: '查閱宣傳單張',
            ENJOYAPP_TITLE: 'Emma by AXA 手機應用程式現已推出！',
            ENJOYAPP_CONTENT: '下載 Emma by AXA 去深入體驗保險及健康夥伴服務。',
            DAY: 'day',
            MONTH: '月份',
            ACHIEVED_DAYS: '總達標日數',
            ACHIEVED_DAYS2: '達標日數',
            POLICT_YEAR: '保單年度',
            MEMBERSHIP_YEAR: ' 會籍年度',
            ACHIEVEMENTSUMMARYTITLE: '達標摘要',
            CAMPAIGN_YEAR: 'Campaign Year',
            CURRENT_CAMPAIGN_YEAR: 'Current Campaign Year',
            PREVIOUS_CAMPAIGN_YEAR: 'Previous Campaign Year',
            CAMPAIGN_PERIOD: 'Campaign Period',
            MEMBERSHIP_END_DAY: '會籍年度完結日期：',
            MEMBERSHIP_YEAR_END_DATE: '會籍年度完結日期：',
            ARCHEVED: '您有',
            DAYS: '天達標日數',
            DAYS2: '天達標日數',
            ACHIEVEMENT_SUMMARY_REMARK: '「達標日數」為每天步行達10000步或以上',
            ACHIEVEMENT_SUMMARY_REMARK1: '* 備註',
            ACHIEVEMENT_SUMMARY_REMARK2:
              '您於首會籍年度（AXA GOAL條款及細則所述之定義）內成功參與AXA GOAL，並獲得首年註冊獎賞。<br/><br/>詳情請參閱 AXA Goal條款及細則。',
            ACHIEVEMENT_SUMMARY_REMARK3: 'only.',
            SH_ACHIEVEMENT_SUMMARY_REMARK:
              '「達標日數」為每天步行達10000步或以上',
            SH_ACHIEVEMENT_SUMMARY_REMARK1: '* 備註',
            SH_ACHIEVEMENT_SUMMARY_REMARK2:
              '*+50天達標日數：您於首會籍年度（AXA Goal (Lite) 條款及細則所述之定義）內成功參與 AXA Goal (Lite)，並獲得首年註冊獎賞。',
            SH_ACHIEVEMENT_SUMMARY_REMARK3: '',
            ACHIEVEMENT_SUMMARY_REMARK_EARLY_BIRD:
              '您於2019年7月26日至8月27日期間成功參與 AXA Goal的早鳥優惠獎賞。<br/><br/>詳情請參閱 AXA Goal條款及細則。',
            ACHIEVEMENT_SUMMARY_EARLY_BIRD_BONUS:
              '（包括${nBonusDays}天早鳥優惠達標日數）',
            ACHIEVEMENT_SUMMARY_FIRST_YEAR_BONUS:
              '（包括${nBonusDays}天首會籍年度註冊獎賞達標日數）',
            ACHIEVEMENT_SUMMARY_SHOW_MORE_MONTHS: '顯示更多月份',
            ACHIEVEMENT_SUMMARY_SHOW_LESS_MONTHS: '顯示更少月份',
            CHANGE_TRACKER: '追蹤裝置',
            NEWBIE: '挑戰者',
            NEWBIE_ACHIVED: '挑戰者',
            CRYSTAL: '水晶級',
            JADE: '翡翠級',
            DIAMOND: '鑽石級',
            YOUR_NEXT_LEVEL: '您下個級別',
            YOUR_ULTIMATE_LEVEL: '您的終極目標',
            NEWBIE_CONTENT: '少於50天達標日數',
            SH_NEWBIE_CONTENT: '125 天達標日數/ 會籍年度可享10%保費回贈',
            RULE_MEMBERSHIP_YEAR: 'AXA Goal 會籍年度',
            SH_RULE_MEMBERSHIP_YEAR: 'AXA Goal (Lite) 會籍年度',
            RULE_MEMBERSHIP_CONTENT:
              '每年記錄步數的時段，此時段內步數記錄將以用作計算保費回贈折扣。',
            SH_RULE_MEMBERSHIP_CONTENT:
              'AXA Goal (Lite) 會籍年度是指每年記錄步數的時段，而此步數記錄將以用作計算保費回贈折扣。',
            CRYSTAL_CONTENT_DAYS: '50 天達標日數',
            CRYSTAL_CONTENT_DISCOUNT: '可享5%保費回贈',
            JADE_CONTENT_DAYS: '125 天達標日數',
            JADE_CONTENT_DISCOUNT: '可享 10% 保費回贈',
            DIAMOND_CONTENT_DAYS: '250 天達標日數',
            DIAMOND_CONTENT_DISCOUNT: '可享 20% 保費回贈',
            MAKE_STEP_CHALLENGE_FUN_TITLE: '如何使步行挑戰變得有趣?',
            MAKE_STEP_CHALLENGE_FUN_CONTENT:
              '請按下方連結以開啟健康拍檔，以參加好玩有趣的每週健步挑戰。所有於健康拍檔計算的步數都會計入該會籍年度的達標日數總和。',
            START_NOW: '開始參加',
            RULES_AND_REGULATIONS: 'AXA Goal 規則',
            SH_RULES_AND_REGULATIONS: 'AXA Goal (Lite) 規則',
            RULES_AND_REGULATIONS_TITLE: '如何獲得高達20％保費回贈？',
            SH_RULES_AND_REGULATIONS_TITLE: '如何獲享保費回贈？',
            RULES_TAB_AXA_GOAL: 'AXA Goal',
            RULES_TAB_AXA_GOAL_LITE: 'AXA Goal (Lite)',
            RULES_TITLE: '10000步 = 1天達標日數',
            SH_RULES_TITLE: '10,000步 = 1天達標日數',
            STARTED_IS_EASY:
              '參加AXA Goal 方法非常簡單：只須於Emma by AXA 的設定版面連接追蹤裝置至您的 Emma by AXA 帳號，以便記錄您的健行步數。<br/>只要每天完成10,000步或以上，便可獲得一天的達標日數。若能在會籍年度內累積指定的達標日數，便可獲得保費回贈。</br>詳情請查閱宣傳單張。',
            SH_STARTED_IS_EASY:
              '參加AXA Goal (Lite) 方法非常簡單：只須於Emma by AXA 的設定版面連接追蹤裝置至您的 Emma by AXA 帳號，以便記錄您的健行步數。<br/><br/>只要每天完成10,000步或以上，便可獲得一天的達標日數。若能在每一會籍年度內累積指定的達標日數，便可獲得保費回贈。<br/></br>詳情請查閱宣傳單張。',
            PARTICIPATED_THI_CAMPAIGN: '',
            ACHIEVEMENT_SUMMARY_MODAL_TITLE: '首年註冊迎新獎賞',
            ACHIEVEMENT_SUMMARY_MODAL_TITLE2: '早鳥優惠獎賞',
            ACHIEVEMENT_SUMMARY_MODAL_CONTENT1:
              '*+50天達標日數：您於首會籍年度（AXA GOAL條款及細則所述之定義）內成功參與AXA GOAL，並獲得首年註冊獎賞。',
            ACHIEVEMENT_SUMMARY_MODAL_CONTENT2:
              '*+75天達標日數：您於2019年7月26日至8月27日期間成功參與 AXA Goal的早鳥優惠獎賞。',
            ACHIEVEMENT_SUMMARY_MODAL_BTN: '明白',
            ACHIEVEMENT_SUMMARY_PREMIUM_REBATE: '保費回贈',
            PREMIUM_REBATE_MODAL_TITLE: 'AXA Goal - 保費回贈等級',
            SH_PREMIUM_REBATE_MODAL_TITLE: 'AXA Goal (Lite) - 保費回贈等級',
            PREMIUM_REBATE_MODAL_OK_BTN: '明白',

            //Settings
            SETTINGS_MY_INFO: '個人資料',
            SETTINGS_LET_US_HELP: '讓我們支援您',
            SETTINGS_SUPPORT_BUTTON: '支援',
            SETTINGS_MACAU_LIFE: '只適用於澳門保單',
            SETTINGS_ANNUITY_AND_ACCUMULATION_RATES:
              '分期給付身故賠償之積存利率/',
            SETTINGS_ANNUITY_AND_ACCUMULATION_RATES_TWO: '積存利率',
            SETTINGS_ABOUT_EMMA: '關於EMMA by AXA',
            SETTINGS_TERMS_AND_CONDITIONS: '條款及細則',
            SETTINGS_PRIVACY_POLICY: '私隱政策及資料使用',
            SETTING_SECURITY_AWARENESS: '防詐騙貼士',
            CLOSE: '關閉',
            VHIS_MODAL_TITLE: 'AXA安盛智尊守慧<br />醫療保障客戶',
            VHIS_MODAL_SUBTITLE: '全年步行挑戰',
            VHIS_MODAL_CONTENT:
              '參加我們的每日健行10,000步全年挑戰，於下<br/>年續保時獲取保費回贈。​',
            MY_WELLNESS_MODAL_CONTENT:
              '健康拍檔陪您挑戰自己，活出更健康的人生！',
            VHIS_MODAL_BTN: 'Download Emma by AXA',
            VHIS_MODAL_LINK: 'AXA Goal 規則',
            MY_WELLNESS_MODAL_LINK: '健康拍檔規則',
            VHIS_DOWNLOAD: '下載',

            // TNC Modal
            TNC_MODAL_TITLE: '條款及條件',
            TNC_MODAL_TNC_1: '我/ 我們明白及同意',
            TNC_MODAL_TNC_2: 'Emma by AXA 的條款及細則',
            TNC_MODAL_TNC_3: '。',
            TNC_MODAL_TNC_ERROR: '必需剔選',
            TNC_MODAL_MARKETING:
              '我/ 我們同意 AXA 安盛根據該聲明使用我/ 我們的個人資料作直銷用途（可選）。',
            TNC_MODAL_PIC_1: '我/ 我們明白及同意',
            TNC_MODAL_PIC_2: ' Emma by AXA 的隱私政策及收集個人資料聲明',
            TNC_MODAL_PIC_3: '（該聲明）。',
            TNC_MODAL_PIC_ERROR: '必需剔選',
            TNC_MODAL_PIPL_1:
              '我/ 我們同意 AXA 安盛處理我/ 我們及由我/ 我們監護的未成年人（如適用）之敏感個人資料 。',
            TNC_MODAL_PIPL_2:
              '我/ 我們同意向中國大陸境內之指定處理者及其合作夥伴提供我/ 我們的個人資料。',
            TNC_MODAL_PIPL_3:
              '我/ 我們同意向中國大陸境外之指定處理者及其合作夥伴提供我/ 我們的個人資料。',
            TNC_MODAL_PIPL_ERROR_1: '必需剔選',
            TNC_MODAL_PIPL_ERROR_2: '必需剔選',
            TNC_MODAL_PIPL_ERROR_3: '必需剔選',
            TNC_MODAL_OK: '接受',
            TNC_MODAL_CLOSE: '關閉',

            // EMMA BANNER
            EMMA_BANNER_OK: '確定',
            EMMA_BANNER_CLOSE: '關閉',

            //EMMA AXA GOAL TEAM CHALLENGE
            TEAM_CHALLENGE_RULES_AND_REGULATIONS: '團隊競賽規則',
            TEAM_CHALLENGE_RULES_MORE_HITS_MORE_FUN_TITLE: '齊齊達標攞滿Fun！',
            TEAM_CHALLENGE_RULES_AIMS:
              '想好玩﹑健康，同時贏得獎賞？好簡單！立即組隊，和其他同事一較高下，看哪一隊能累積最多達標日數！',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_POINTS_TITLE: '怎樣累積達標日數？',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_POINTS_CONTENT_P1:
              '一日步行10,000步=1個達標日！​',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_POINTS_CONTENT_P2:
              '同時更可賺取5 Fitpoints，於健康拍檔內兌換獎賞。',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_TITLE: '怎樣開始？',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_1: '建立/加入隊伍',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_1_DESC:
              '建立/加入一隊由4至8位同事組成的隊伍',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_2: '連接追蹤裝置',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_3: '參加競賽',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_3_DESC:
              '成功組隊後，您或者任何一個隊員只需簡單一click，即可參加競賽',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_4: '動起來！',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_4_DESC:
              '由競賽開始當日起，您的步數將被自動計算，記得每天完成您的步行目標',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_5: '查看隊伍排名',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_5_DESC:
              '您可隨時透過健康拍檔中的團隊競賽分頁檢視排行榜',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_6: '完成競賽',
            TEAM_CHALLENGE_RULES_HOW_TO_GET_START_STEP_6_DESC:
              '貴公司將會宣佈勝出隊伍！',
            TEAM_CHALLENGE_RULES_BTN_CREATE_TEAM: '建立隊伍',
            TEAM_CHALLENGE_RULES_BTN_GOT_INVITATION: '加入隊伍',
            TEAM_CHALLENGE_RULES_FOOTER_TITLE: '重要事項',
            TEAM_CHALLENGE_RULES_FOOTER_CONTENT:
              '若您同時於 Emma 連接多於一個追蹤裝置，只有每天最高步數的單一項數據會被納入計算競賽成績',

            // Marketplace
            HOMEPAGE_MARKETPLACE_SEE_ALL_SERVICE: '查看全部',
            MYPRIVILEGES_LABEL: '貼心禮遇',
            MANNING_HEALTH_COLLABORATION: '萬寧健康合作',
            MANNING_APPOINTMENT_SELECTED_POLICY: '*選擇保障計劃',
            MANNING_APPOINTMENT_SELECTED_POLICY_PLACEHOLDER: '選擇計劃',
            MANNING_APPOINTMENT_INSURED_NAME: '*受保人名稱',
            MANNING_APPOINTMENT_INSURED_NAME_PLACEHOLDER: '選擇受保人名稱',
            MANNING_APPOINTMENT_SELECT_A_MANNING_STORE: '*選擇萬寧分店',
            MANNING_APPOINTMENT_MANNING_STORE_PLACEHOLDER: '選擇萬寧分店',
            MANNING_APPOINTMENT_PREFERRED_DATE: '*預約日期',
            MANNING_APPOINTMENT_PREFERRED_TIME: '*預約時間',
            MANNING_APPOINTMENT_CLOSED: '關閉',
            MANNING_APPOINTMENT_PREFERRED_TIME_PLACEHOLDER: '選擇時間',
            MANNING_APPOINTMENT_CONTACT_EMAIL: '*受保人的聯絡電郵',
            MANNING_APPOINTMENT_MOBILE_NO: '*受保人的手提電話號碼',
            MANNING_APPOINTMENT_CONFIRM_BOOKING: '提交預約',
            MANNING_APPOINTMENT_DIALOG_BUTTON_CANCEL: '取消',
            MANNING_APPOINTMENT_DIALOG_BUTTON_TRY_AGAIN: '再試一次',
            MANNING_APPOINTMENT_SUCCESS_TITLE: '完成! 我們已收到您的預約!',
            MANNING_APPOINTMENT_SUCCESS_SUB_TITLE: '您的預訂已提交.',
            MANNING_APPOINTMENT_SUCCESS_STEP_TITLE: '預約步驟：',
            MANNING_APPOINTMENT_SUCCESS_STEP1_DES:
              '1. 萬寧將會於一至兩個工作天內致電並與您確認預約資料',
            MANNING_APPOINTMENT_SUCCESS_STEP2_DES:
              '2. 在預約當日請帶備預約電郵及您的身份證明文件以作確認',
            MANNING_APPOINTMENT_SUCCESS_STEP3_DES:
              '3. 在您所選的萬寧分店進行健康評估',
            MANNING_APPOINTMENT_DATE: '預約日期：',
            MANNING_APPOINTMENT_BOOKING_NAME: '預約姓名：',
            MANNING_APPOINTMENT_POLICY_NUMBER: '保障計劃號碼：',
            MANNING_APPOINTMENT_EREQUEST_NUMBER: 'eRequest號碼：',
            MANNING_APPOINTMENT_LOCATION: '萬寧分店地址：',
            MANNING_APPOINTMENT_TIME: '預約時間：',
            MANNING_APPOINTMENT_TEL: '分店電話：',
            MANNING_APPOINTMENT_REQUESTED_DESC:
              '我們會將以下資料於24小時內以電郵送到您提供的聯絡電郵地址。',
            MANNING_EMAIL_ERROR_MSG: '電郵格式錯誤',
            MANNING_MOBILE_ERROR_MSG: '手機號碼格式錯誤',
            MANNING_APPOINTMENT_SUBMIT_ERROR_TITLE: '噢。。。',
            MANNING_APPOINTMENT_SUBMIT_ERROR_MSG:
              '很抱歉剛剛發生了一個故障。請再試一次。',
            MANNING_APPOINTMENT_REQUIRED_FIELDS: '*必填項',
            MEMBERSHIP_PERIOD: '會籍年度',
            COMMON_MEMBERSHIP_YEAR: '會籍年度',
            CURRENT_MEMBERSHIP_YEAR: '現時的會籍年度',
            PREVIOUS_MEMBERSHIP_YEAR: '上一個會籍年度',
            MANNING_APPOINTMENT_SELECT_ADVANCE: '您只能選擇3週內的日期',
            MANNING_APPOINTMENT_GOT_IT: '知道了',
            WORDS: '字',
            MIN: '分',
            CONNECT: '連接',
            HELP_APP_TITLE: '我們樂意提供協助​',
            HELP_APP_PHONE_NUMBER: '(852) 2802 2812',
            HELP_APP_WEB_SITE: 'https://www.axa.com.hk/zh/axa-goal-support',
            // FANCL
            FANCL_HEALTH_COLLABORATION: 'FANCL 皮膚及體質分析服務',
            FANCL_APPOINTMENT_SELECTED_POLICY: '*選擇保障計劃',
            FANCL_APPOINTMENT_SELECTED_POLICY_PLACEHOLDER: '選擇計劃',
            FANCL_APPOINTMENT_SELECTED_POLICY_NOT_APPLICABLE: '不適用',
            FANCL_APPOINTMENT_SELECT_GENDER: '*性別',
            FANCL_APPOINTMENT_GENDER_PLACEHOLDER: '性別',
            FANCL_APPOINTMENT_GENDER_MALE: '男',
            FANCL_APPOINTMENT_GENDER_FEMALE: '女',
            FANCL_APPOINTMENT_GENDER_PREFER_NOT_TO_DISCLOSE: '不願透露',
            FANCL_APPOINTMENT_NAME: '*中文全名',
            FANCL_APPOINTMENT_SELECT_A_FANCL_STORE: '*選擇Fancl分店',
            FANCL_APPOINTMENT_FANCL_STORE_PLACEHOLDER: '選擇Fancl分店',
            FANCL_APPOINTMENT_PREFERRED_DATE: '*預約日期',
            FANCL_APPOINTMENT_PREFERRED_TIME: '*預約時間',
            FANCL_APPOINTMENT_CLOSED: '關閉',
            FANCL_APPOINTMENT_PREFERRED_TIME_PLACEHOLDER: '選擇時間',
            FANCL_APPOINTMENT_CONTACT_EMAIL: '*聯絡電郵',
            FANCL_APPOINTMENT_MOBILE_NO: '*手提電話號碼',
            FANCL_APPOINTMENT_CONFIRM_BOOKING: '好的，繼續',
            FANCL_APPOINTMENT_DIALOG_BUTTON_CANCEL: '取消',
            FANCL_APPOINTMENT_DIALOG_BUTTON_TRY_AGAIN: '再試一次',
            FANCL_APPOINTMENT_SUCCESS_TITLE: '完成! 我們已收到您的預約!',
            FANCL_APPOINTMENT_SUCCESS_SUB_TITLE: '您的預訂已提交.',
            FANCL_APPOINTMENT_SUCCESS_STEP_TITLE: '預約步驟：',
            FANCL_APPOINTMENT_SUCCESS_STEP1_DES:
              '1. FANCL會於兩個工作天內透過WhatsApp或致電與您聯絡並確認預約',
            FANCL_APPOINTMENT_SUCCESS_STEP2_DES:
              '2. 在預約當日帶備預約電郵作確認',
            FANCL_APPOINTMENT_SUCCESS_STEP3_DES:
              '3. 在您所選的FANCL分店進行服務',
            FANCL_APPOINTMENT_DATE: '預約日期：',
            FANCL_APPOINTMENT_BOOKING_NAME: '預約姓名：',
            FANCL_APPOINTMENT_POLICY_NUMBER: '保障計劃號碼：',
            FANCL_APPOINTMENT_EREQUEST_NUMBER: 'eRequest號碼：',
            FANCL_APPOINTMENT_GENDER: '性別：',
            FANCL_APPOINTMENT_LOCATION: 'FANCL分店地址：',
            FANCL_APPOINTMENT_TIME: '預約時間：',
            FANCL_APPOINTMENT_REQUESTED_DESC:
              '我們會將以下資料於24小時內以電郵送到您提供的聯絡電郵地址。',
            FANCL_APPOINTMENT_REMINDER:
              '#受疫情影響，FANCL分店開放時間可能會有所不同。實際預約服務FANCL會向您確認。',
            FANCL_EMAIL_ERROR_MSG: '電郵格式錯誤',
            FANCL_MOBILE_ERROR_MSG: '手機號碼格式錯誤',
            FANCL_NAME_ERROR_MSG: '名字格式錯誤',
            FANCL_APPOINTMENT_SUBMIT_ERROR_TITLE: '噢。。。',
            FANCL_APPOINTMENT_SUBMIT_ERROR_MSG:
              '很抱歉剛剛發生了一個故障。請再試一次。',
            FANCL_APPOINTMENT_REQUIRED_FIELDS: '*必填項',
            FANCL_APPOINTMENT_SELECT_ADVANCE: '請選擇2個工作天後至3週內的日期',
            FANCL_APPOINTMENT_GOT_IT: '知道了',
            // Woman Product
            WOMEN_PRODUCT_BENEFIT_COVERAGE: '保障內容',
            WOMEN_PRODUCT_POLICY_LABEL: '計劃名稱',
            WOMEN_PRODUCT_POLICY_TIPS:
              '*此保險賠償表須受限於本保單的條款，敬請瀏覽本頁時同時閱讀本保單的條款。',
            PRIVILEGES_CATEGORY_TITLE: '可享哪些禮遇？',
            WOMEN_PRODUCT_EXPLORE_MORE: '發掘更多',
            WOMANPRODUCT_ENQUIRY: '查詢',
            WOMEN_PRODUCT_ENQUIRY_DESC1: '如有任何疑問，請​',
            WOMEN_PRODUCT_ENQUIRY_DESC2: '聯絡我們。',
            WOMEN_PRODUCT_BENEFIT_ITEMS: '保障範圍',
            WOMEN_PRODUCT_MAKE_A_APOINTMENT: '立即預約',
            WOMEN_PRODUCT_KEY_EXCULSIONS: '主要不保事項',
            WOMEN_PRODUCT_PRODUCT_BROCHURE: '產品說明書​',
            WOMEN_PRODUCT_REMARKS: '備註',
            WOMEN_PRODUCT_MAKE_APPOINTMENT_TITLE:
              '請選擇以下指定服務供應商進行預約',
            WOMEN_PRODUCT_MAKE_APPOINTMENT_SUB_TITLE:
              '立即預約鍵會接通第三方提供者的預約熱線',
            WOMEN_PRODUCT_REMAINING_VISIT_TIME_LABEL: '每個保單年度剩餘次數​',
            WOMEN_PRODUCT_CHECK_COVERAGE_REMARK: '產品備註',
            WOMEN_PRODUCT_DOWNLOAD_DOCUMENT: '下載表格及文件',
            WOMEN_PRODUCT_RESERVATION_BTN_TEXT: '立即預約',

            // Membership Tutorial
            MEMBERSHIP_NEXT: '繼續',
            MEMBERSHIP_CLOSE: '關閉',

            // Error Modal
            ERROR_MODAL_TITLE: '暫時無法使用服務',
            ERROR_MODAL_MESSAGE:
              '由於程式出現問題，請於稍後重新嘗試。 如果問題持續發生，請與我們聯絡以提供協助。',
            ERROR_MODAL_BUTTON_CANCEL: '取消',
            ERROR_MODAL_BUTTON_OK: '好的',
            ERROR_MODAL_BUTTON_TRY_AGAIN: '再試一次',
            SELECT_YOUR_ELIGIBLE_POLICY: '請選擇您符合條件的保單：',
            SELECT_YOUR_ELIGIBLE_POLICY_DESC:
              '請注意每項保單的會員期限，因為您所達到的天數可能會受到影響。',
            WELCOME_TO_AXA_GOAL: '歡迎到 AXA Goal',
            NEXT: '好的，繼續',
            EMPTY_DATE_FIELD: '日期欄位不能為空',
            EMPTY_MONTH_FIELD: '月份欄位不能為空',
            EMPTY_YEAR_FIELD: '年份欄位不能為空',
            DATE_INVALID: '日期不正確',
            BIRTHDATE_LOW_THAN_6_MONTH: '家庭成員必須在6個月大-80歲之間',
            BIRTHDATE_LOW_THAN_18: '用戶必須年滿18歲',
            BIRTHDATE_MORE_THAN_65: '免費保障只適用於65歲或以下之客戶',
            BIRTHDATE_MORE_THAN_80: '免費保障只適用於80歲或以下之客戶',
            OFFERS_FORM_POLICY_MODAL_HEADER:
              'AXA安盛「疫苗副作用保障」計劃條款與細則',
            OFFERS_FORM_POLICY_MODAL_DETAILS:
              '1.\tAXA安盛「疫苗副作用保障」計劃（「本計劃」）由安盛保險（百慕達）有限公司（於百慕達註冊成立的有限公司）（「AXA安盛」）提供，並受以下條款與細則約束。 <br><br>' +
              '2.\t本計劃申請期從2020年11月30日開始，先到先得，額滿即止（下稱「推廣期」）。<br><br>' +
              '<b><u>申請資格</u></b><br><br>' +
              '3.\t所有香港／澳門特別行政區（分別下稱「香港」或「澳門」）居民皆合資格申請本計劃（下稱「合資格申請者」）。合資格申請者必須持有有效香港或澳門身份證，並於登記當日年齡介乎18至65歲。<br><br>' +
              '4.\t每位合資格申請者可於推廣期内額外替最多4位家庭成員（下稱「合資格家庭成員」）進行登記。合資格家庭成員必須爲合資格申請者之配偶或子女，持有有效香港或澳門身份證，並於登記當日為65歲或以下。合資格申請者明白本計劃並不適用於香港及澳門境外之人士。<br><br>' +
              '5.\t合資格申請者於推廣期内成功下載Emma by AXA手機應用程式並登記參與本計劃後，將收到載有登記編號及本計劃保障詳情之確認電郵。保障於合資格申請者收到上述電郵後方會生效。<br><br>' +
              '<b><u>合資格疫苗</u></b><br><br>' +
              '6.\t疫苗包括首劑、後續劑量及加强劑均須受美國食品藥物管理局或本地衛生當局認可，並由香港或澳門註冊醫生於任何公立醫院、私家醫院或註冊診所處方。為免異議，於香港或澳門境內接受由註冊醫生處方之疫苗亦予以接受。<br><br>' +
              '7.\t根據世界衛生組織，接種疫苗後的不良反應（AEFI）有以下含義：<br><br>' +
              '·\t任何於接種疫苗後出現的負面醫療症狀，但不一定是由於接種疫苗所致。不良反應可包括任何負面或非意料中的症狀，異常的化驗結果、症狀或疾病。<br><br>' +
              '·\t接種疫苗後的不良反應（AEFI）可分爲5類：疫苗產品相關反應、疫苗質量瑕疵相關反應、免疫出錯相關反應、疫苗接種焦慮相關反應及巧合事件。<br><br>' +
              '·\t不良反應可再細分爲過敏性反應、局部性反應（如注射位置泛紅、疼痛、腫脹）、系統性反應（如發燒、敗血症、皮疹、疲勞等）以及神經性反應（包括癲癇、腦病、腦膜炎、腦炎、臂神經炎及格林巴利-綜合症）。<br><br>' +
              '<b><u>註冊醫生及醫院的定義</u></b><br><br>' +
              '8.\t註冊醫生是指符合以下資格的西醫：<br><br>' +
              '(a) 具有正式資格並已按香港法例第161章《醫療註冊條例》在香港醫務委員會註冊，或在澳門特別行政區內由本公司絕對真誠及合理地認為具有同等效力的團體註冊; 及<br><br>' +
              '(b) 在香港或澳門，經本地法例許可提供相關醫療服務。若該醫生未能按香港或澳門法例下由本公司絕對真誠及合理地認爲具有同等效力的團體註冊，本公司必須作出合理的判斷，以決定該醫生是否仍被視為符合資格及已註冊。<br><br>' +
              '9.\t住院治療是指按香港或澳門特別行政區本地法律妥為成立及註冊為醫院的機構， 為不適及受傷的住院病人提供醫療服務， 並 <br><br>' +
              '·\t具備診斷及進行大型手術的設施；<br><br>' +
              '·\t由持牌或註冊護士提供24小時護理服務；<br><br>' +
              '·\t由1位或以上註冊醫生駐診；及<br><br>' +
              '·\t非主要作為診所、 戒酒或戒毒中心、 自然療養院、 水療中心、 護理或療養院、 寧養或紓緩護理中心、 復康中心、 護老院或同類機構。<br><br>' +
              '<b><u>計劃保障内容</u></b><br><br>' +
              '10.\t本計劃之保障内容覆蓋由登記當日起計1年內（下稱「計劃保障期」）接種之疫苗後14日内的不良反應（AEFI）所致之住院治療或身故。<br><br>' +
              '11.\t住院現金保障適用於合資格申請者及／或合資格家庭成員在醫療所需的情況下，按註冊醫生的建議以住院病人身份入住醫院以接受醫療服務 ; 合資格申請者及／或合資格家庭成員必須入住醫院不少於連續6小時。惟因急症在醫院進行手術或其他醫療服務的急症治療時，則沒有最低住院時間要求。住院必須以醫院開立的每日病房費單據作證明，且合資格申請者及／或合資格家庭成員必須在整個住院期間連續留院。<br><br>' +
              '12.\t如合資格申請者及／或合資格家庭成員因在計劃保障期內接種疫苗後的不良反應（AEFI）而致命，則可獲得身故恩恤金。<br><br>' +
              '13.\t合資格申請者及／或合資格家庭成員於計劃保障期內：<br><br>' +
              '(i) 在接種疫苗後14日内因接種疫苗後的不良反應（AEFI）而需入院治療，合資格申請者將可獲支付每日700港元，最高達10日之住院現金保障款項；及／或<br><br>' +
              '(ii) 在接種疫苗後14日内因接種疫苗後的不良反應（AEFI）及其併發症而致命，一次性一筆過10萬港元之身故恩恤金款項將發放予合資格申請者之遺產。 <br><br>' +
              '14.\t每位合資格申請者及／或合資格家庭成員於計劃保障期内可享有最高達10日住院現金保障及／或最多一次身故保障。<br><br>' +
              '15.\t住院現金保障及／或身故恩恤金並不適用於合資格申請者及／或合資格家庭成員於計劃保障期後確診的接種疫苗後的不良反應（AEFI）。<br><br>' +
              '16.\t任何與本計劃有關之理賠款項均受相關法律約束，並需通過AXA安盛之標準理賠審查程序。<br><br>' +
              '<b><u>不保事項</u></b><br><br>' +
              '17.\t除因接種疫苗而引起的副作用以外，由任何其他因素，包括因下列情況而直接或間接地導致、促致或產生（全部或部分）合資格申請者及／或合資格家庭成員之住院治療或身故， AXA安盛將不會支付任何住院現金保障及／或身故保障 : <br><br>' +
              '(i) 任何自我傷害或自殺（不論當事人當時神志是否正常）及<br><br>' +
              '(ii) 使用任何類型的生化武器進行恐怖襲擊<br><br>' +
              '<b><u>理賠</u></b><br><br>' +
              '18.\t所需證明文件（必須於求診／治療／身故日期起90日内提交，以日期較後者為準）：<br><br>' +
              '·\t香港或澳門身份證，或相關身份證明文件副本; <br><br>' +
              '·\t關係證明（如適用）；<br><br>' +
              '·\t診斷證明書（證明不良反應由經註冊醫生處方，於計劃保障期內接種之認可疫苗所引致）及住院證明或合法死亡證明文件（如適用）；<br><br>' +
              '·\t由香港或澳門高等法院所簽發的遺產管理書（適用於申領身故恩恤金）。<br><br>' +
              '19.\t理賠申請方法：<br><br>' +
              '(i) 經www.axa.com.hk 下載住院及手術索償申請表 I（住院治療保障）或經www.axa.com.hk 下載身故索償申請表 I（身故恩恤金）<br><br>' +
              '(ii) 透過電郵提交已填妥之表格，標題請列明【AXA安盛疫苗副作用保障計劃索償 – [登記編號] 】，發送至life.claims@axa.com.hk（香港）或ma.enquiry@axa.com.mo（澳門）。<br><br>' +
              '20.\t合資格申請者及／或合資格家庭成員之理賠申請均應由合資格申請者作出。<br><br>' +
              '<b><u>終止事項</u></b><br><br>' +
              '21.\t上列住院現金保障及身故恩恤金於相應的保障期結束後將自動失效。<br><br>' +
              '22.\tAXA安盛保留權利隨時更改或終止本計劃（全部或部份）及／或更改相關條款與細則而毋須另行通知。如有任何爭議， AXA安盛保留最終決定權。<br><br>' +
              '23.\t本條款與細則受香港法律管限。如本條款與細則的英文版本與其他語文版本之間有任何不一致及／或遺漏，以英文版本為準。<br><br>' +
              '如您不希望接收由AXA安盛發出之宣傳或直接促銷資料，請與安盛保險（百慕達）有限公司（於百慕達註冊成立的有限公司）個人資料保護主任聯絡（地址：香港銅鑼灣勿地臣街 1 號時代廣場 2 座 20 樓 2001 室）。AXA安盛會在不收取任何費用的情況下確保不會將閣下納入日後的直接促銷活動之中。<br><br>' +
              '（只適用於香港及澳門特別行政區）<br><br>',
            REVIEW_INFORMATION: '確認資料',
            CONFIRM: '確認',
            OFFERS_COMFIRM_SUCCESS_TITLE: '登記成功！',
            OFFERS_COMFIRM_SUCCESS_MSG:
              '您已成功登記免費AXA安盛「運動意外保」計劃。計劃詳情包括保障內容及保障期限將於稍後發送至您的電子郵箱。',
            OFFERS_COMFIRM_UNSUCCESS_TITLE: '登記不成功',
            OFFERS_COMFIRM_UNSUCCESS_MSG:
              '您已於較早前完成登記免費AXA安盛「運動意外保」計劃，詳情請參閱您的確認電郵。如有查詢請致電計劃熱線${tel}<br/>點擊以下按鈕以發掘更多優惠吧！',
            OFFERS_COMFIRM_SUCCESS_BUTTON_TEXT: '發掘更多優惠',
            NAME_PLACEHOLDER: '您的姓名',
            EMAIL_PLACEHOLDER: '您的電郵地址',
            DAY_PLACEHOLDER: '日',
            MONTH_PLACEHOLDER: '月',
            YEAR_PLACEHOLDER: '年',
            GENDER_PLACEHOLDER: '男／女',
            GENDER_MALE_OPTION: '男',
            GENDER_FEMALE_OPTION: '女',
            MOBILE_PLACEHOLDER: '您的手機號碼',
            RELATIONSHIP_PLACEHOLDER: '配偶 / 子女 / 父母 / 配偶父母',
            RELATIONSHIP_SPOUSE_OPTION: '配偶',
            RELATIONSHIP_CHILD_OPTION: '子女',
            RELATIONSHIP_PARENT_OPTION: '父母',
            RELATIONSHIP_PARENT_IN_LAW_OPTION: '配偶父母',
            BOOK_NOW: '立即預約',

            // Login error
            LOGIN_ERROR_TITLE: '系統暫時無法使用',
            LOGIN_ERROR_DESC:
              '抱歉，系統暫時無法使用，請稍後再試。 如有查詢，請聯絡AXA客戶服務熱線。（參考編號Error 003）',

            // offer lead form contact time
            MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_ANY_TIME: '任何時間',
            MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_IN_THE_MORNING: '早上',
            MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_LUNCH_TIME: '中午',
            MEET_OUR_CONSULTANT_PREFERRED_CONTACT_TIME_IN_THE_AFTERNOON: '下午',
            OFFERS_SUBMIT_LEAD_FORM_SUCCESS_TITLE: '我們將儘快與您聯絡',
            OFFERS_SUBMIT_LEAD_FORM_SUCCESS_MSG:
              '感謝${name}對${productName}的查詢。我們的理財顧問將於${time}與您聯絡。',
            OFFERS_SUBMIT_LEAD_FORM_SUCCESS_BUTTON: '知道了',
            OK_I_UNDERSTAND_AND_LETS_PROCEED: '好的，繼續',
            NO_THANKS_BRING_ME_BACK: '不用了，我要回去',
            REVIEW_CONSULTANT_MOBILE_NO: '理財顧問電話號碼',
            REVIEW_PROMOTION_CODE: '推廣代碼',
            XPAPI_MANDATORY_PROMOCODE_NOTVALID:
              '您所輸入的推廣代碼無效。無推廣代碼用戶請於2022年1月1日或之後重試。',
            XPAPI_OPTIONAL_PROMOCODE_NOTVALID:
              '請輸入有效的推廣代碼（可選填）。',

            // Offer tab
            UI_MY_PRIVILEGES_TAB_PRIVILEGES: 'AXA BetterMe',
            UI_MY_PRIVILEGES_TAB_OFFERS: '優惠',
            UI_MY_PRIVILEGES_VALID_UNTIL: '有效期至: ',
            UI_MY_PRIVILEGES_PRODUCT_TITLE: '熱門優惠',
            UI_MY_PRIVILEGES_CAMPAIGNS_TITLE: '最新活動',
            UI_MY_PRIVILEGES_TERMS_APPLY: '*優惠受條款及細則約束',
            BIRTHDATE_LESS_THAN_CURRENT_DATE: '家庭成員必須在6個月大-80歲之間',

            // Health Keeper Modal View
            HEALTH_KEEPER_MODAL_VIEW_HEADER_DESC: '請點擊以下連結並仔細閱讀。',
            HEALTH_KEEPER_MODAL_VIEW_HEADER_CLOSE_BUTTON: '關閉',
            HEALTH_KEEPER_MODAL_VIEW_BODY_TITLE: '條款及細則',
            HEALTH_KEEPER_MODAL_VIEW_BODY_DESC:
              '在以下的方格內勾選，即表示您確認已閱讀並同意以下條款:',
            HEALTH_KEEPER_MODAL_VIEW_BODY_CHECK_WELLNESS: '健康拍檔',
            HEALTH_KEEPER_MODAL_VIEW_BODY_CHECK_TERMS: '條款及細則',
            HEALTH_KEEPER_MODAL_VIEW_FOOTER_BUTTON: '我同意',

            //Benefit EB remark
            BENEFIT_EB_REMARK:
              '上述内容僅列出閣下保障計劃的福利概要<br/> <br/>請前往「<a class ="benefit-eb-remark-font-link">下載表格及文件 – 福利詳情</a>」以了解更多詳情 (包括但不限於福利注釋、福利附註如：有關專科門診治療轉介信之要求)<br/><br/>如上述內容和該僱員福利醫療保障保險簡介有任何抵觸或不相符之處，應以該僱員福利醫療保障保險簡介為準',
            BENEFIT_EB_REMARK_DOCUMENT_NAME: '員工福利醫療保險政策摘要',

            //Benefit Coverage(Check Coverage)
            WOMEN_PRODUCT_POLICYNO_LABEL: '保單號碼',
            WOMEN_PRODUCT_INSUREDNAME_LABEL: '受保人',
            WOMEN_PRODUCT_SHOWBENEFIT_LABEL: '您的團體醫療計劃福利',
            WOMEN_PRODUCT_SHOWBENEFIT_REMARK:
              '*使用時請注意每種好處的用法或金額限制。',
            WOMEN_PRODUCT_TAXDE_DUCTIONBANNER_TITLE: '想要獲得更多的覆蓋範圍？',
            WOMEN_PRODUCT_BENEFIT_DORPDOWN_ALL: '所有',
            WOMEN_PRODUCT_BENEFIT_DORPDOWN_BENEFITS: ' ',

            // Customer Profile
            CUSTOMER_PROFILE: '我的賬戶',
            CUSTOMER_PROFILE_CHANGE_CONTACT_TITLE: '更改保單聯絡人資料',
            CUSTOMER_PROFILE_CONTACT_DETAILS_TITLE: '更改聯絡資料',
            CUSTOMER_PROFILE_UPDATE_MOBILE_TITLE: '更新手機號碼',
            CUSTOMER_PROFILE_UPDATE_EMAIL_TITLE: '更新電郵地址',
            CUSTOMER_PROFILE_POLICY_GROUP_OPTION_LABEL:
              '下列一般保險及個人醫療保單的聯絡資料將被更新：',
            CUSTOMER_PROFILE_POLICY_GROUP_OPTION_REMARK1: '重要提示：',
            CUSTOMER_PROFILE_POLICY_GROUP_OPTION_REMARK2:
              '請留意您其他一般保單（包括經銀行購買的保單）的聯絡資料將同時被更新。如有任何查詢，請致電我們的客戶服務熱線。',
            CUSTOMER_PROFILE_POLICY_GROUP_OPTION_REMARK3:
              '若您有經保險中介人購買的保單，我們建議您向他們提供相同的資料更新。',
            CUSTOMER_PROFILE_POLICY_OPTION_ENQUIRY:
              '如有查詢，請致電我們的客戶服務熱線。',
            CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_1:
              '在您提交${progressType}後，它將在${workingDay}個工作日內更新。然後您將會收到確認電郵/手機短訊。',
            CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_2:
              '在您提交${progressType}後，它將在${workingDay}個工作日內更新。',
            CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_EMAIL: '電郵地址更新指示',
            CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_MOBILE: '手機號碼更新指示',
            CUSTOMER_PROFILE_POLICY_DETAIL_REMARK_BOTH:
              '電郵地址及手機號碼更新指示',
            CUSTOMER_PROFILE_UPDATE_ADDRESS_TITLE: '更新您的通訊地址',
            CUSTOMER_PROFILE_UPDATE_ADDRESS_MAP_VIEW_TITLE: '搜尋地址',
            CUSTOMER_PROFILE_UPDATE_ADDRESS_INPUT_FIELD_REQUIRED:
              '此欄位必須填寫',
            CUSTOMER_PROFILE_UPDATE_ADDRESS_INPUT_FIELD_EN: '僅支援英文地址',
            CUSTOMER_PROFILE_UPDATE_ADDRESS_MANDATORY: '[ZH] Mandatory field',
            CUSTOMER_PROFILE_UPDATE_ADDRESS_EXCEED_CHARACTER_LIMIT:
              '超出字數限制',

            // Password
            INPUT_ENTER_PASSWORD: '請輸入新密碼',
            INPUT_CONFIRM_PASSWORD: '請再次輸入新密碼',
            INPUT_EMPTY_FIELD: '必填資料',
            INPUT_INCORRECT_FORMAT: '格式錯誤',
            INPUT_INCORRECT_REPETITION: '密碼不能包含連續相同的3個字符',
            INPUT_INCORRECT_SPACE: '密碼不能有空格',
            INPUT_INCORRECT_LOWER: '密碼必須包含小寫字母',
            INPUT_INCORRECT_UPPER: '密碼必須包含大寫字母',
            INPUT_INCORRECT_DIGIT: '密碼必須包含數字',
            INPUT_INCORRECT_SEQUENCE: '密碼不能包含六個連續數字/字母',
            INPUT_INCORRECT_SPECIAL: '密碼必須包含符號　例如： *&^$#$%^&*)(',
            INPUT_INCORRECT_LENGTH: '密碼必須為8到16個字符',
            INPUT_INCORRECT_MATCH: '密碼不符',

            //otp
            OTP_ENTER_CODE: '輸入${length}位數字驗證碼',
            OTP_TEXT: '請檢查您的手機短訊，並在下方輸入驗證碼。',
            OTP_EMAIL_TEXT: '請檢查您的電郵信箱，並在下方輸入驗證碼。',
            OTP_DOT_NOT_GET_CODE: ' 還未收到驗證碼？ ',
            OTP_RESEND: '重新發送',

            // insure
            POLICY_LIST_INSURE_SUBTITLE: '請選擇您的保單(你是保單受保人):',

            //longLoading
            LONG_LOADING_TEXT: '謝謝你的耐心等待，此頁面即將被加載。',

            //axa goal dashboard
            AXA_GOAL_DASHBOARD_TITLE: 'AXA Goal',
            AXA_GOAL_DASHBOARD_WELCOME: '歡迎到 AXA Goal',
            AXA_GOAL_DASHBOARD_YOUR_POLICY: '您的保單',
            AXA_GOAL_DASHBOARD_YOUR_AND_FAMILY_POLICY: '您的受保人與您的保單',
            AXA_GOAL_DASHBOARD_YOUR_FAMILY: '您受保人的保單',
            AXA_GOAL_DASHBOARD_SEE_ALL: '顯示全部 ({policies})',
            AXA_GOAL_DASHBOARD_INSURED_NAME: '受保人',
            AXA_GOAL_DASHBOARD_END_DATE: '會籍年度完結日',
            AXA_GOAL_DASHBOARD_ACHIEVED_DAYS: '達標日數*',
            AXA_GOAL_DASHBOARD_UPDATED_WITHIN_HOURS:
              '*達標日數會於48小時內更新',
            AXA_GOAL_DASHBOARD_KNOW_MORE: '詳細紀錄',
            AXA_GOAL_DASHBOARD_BANNER_TITLE: '健康拍檔',
            AXA_GOAL_DASHBOARD_BANNER_TEXT:
              '參加好玩的健步挑戰讓步行變得更有趣',
            AXA_GOAL_DASHBOARD_BANNER_BUTTON: '開始參加',
            AXA_GOAL_DASHBOARD_SUPPORT: '支援',
            AXA_GOAL_DASHBOARD_SUPPORT_TEXT: '如有疑問，請按此',
            AXA_GOAL_DASHBOARD_SUPPORT_LOWERCASE: '支援',
            AXA_GOAL_DASHBOARD_TRACKING_DEVICE: '追蹤裝置',
            AXA_GOAL_DASHBOARD_VIEW_ALL_TEXT:
              '最多顯示5張保單，要查閱全部保單請按「顯示全部」',
            AXA_GOAL_DASHBOARD_VIEW_ALL_BUTTON: '顯示全部',
            AXA_GOAL_DASHBOARD_NO_POLICY_TEXT: '抱歉，未有任何AXA Goal保單',

            AXA_GOAL_SCENAVIO_GRANT_ACCESS_TEXT:
              '授權予年滿18歲的家人，讓他們能夠參與AXA Goal讓你賺取高達20％保費回贈',
            AXA_GOAL_SCENAVIO_GRANT_ACCESS_BUTTON_TEXT: '前往「我的受保人」',
            AXA_GOAL_SCENAVIO_REMINDER_TEXT: '您的受保人還未註冊AXA Goal',
            AXA_GOAL_SCENAVIO_REMINDER_BUTTON_TEXT: '提醒受保人',
            AXA_GOAL_SCENAVIO_ENROLLMENT_TEXT_HK: '參加AXA Goal',
            AXA_GOAL_SCENAVIO_ENROLLMENT_TEXT_MACAU: '參加AXA Goal',
            AXA_GOAL_SCENAVIO_ENROLLMENT_BUTTON_TEXT: '立即參加',
            AXA_GOAL_SCENAVIO_OVER_AGE_TEXT:
              '[ZH]Please note only insured people over the age of 18 can join AXA Goal.',
            AXA_GOAL_SCENAVIO_ERROR_TEXT:
              '噢！系統發生錯誤，您可能有多於一個Emma by AXA帳戶，請聯絡客戶服務。',
            AXA_GOAL_SCENAVIO_ERROR_BUTTON_TEXT: '聯絡我們',

            // AXA Goal See All Policy Page
            AXA_GOAL_SEE_ALL_POLICY_TITLE: '全部 AXA Goal 保單',
            AXA_GOAL_SEE_ALL_POLICY_TITLE_MY_ACTION_REQUIRED: '需處理的保單',
            AXA_GOAL_SEE_ALL_POLICY_TITLE_MY_POLICY: '您的保單',
            AXA_GOAL_SEE_ALL_POLICY_TITLE_MY_FAMILY: '您受保人的保單',

            // AXA Goal Support
            AXA_GOAL_SUPPORT_TITLE: 'AXA Goal 支援',
            MY_WELLNESS_SUPPORT_TITLE: '健康拍檔支援',
            AXA_GOAL_SUPPORT_QUESTION: '常見問題',
            AXA_GOAL_SUPPORT_RULES: 'AXA Goal 規則',
            MY_WELLNESS_SUPPORT_RULES: '健康拍檔規則',
            AXA_GOAL_SUPPORT_TRACKING_DEVICE: '如何連接追蹤裝置',
            AXA_GOAL_SUPPORT_ACHIEVED_DAYS: '達標日數不正確',
            AXA_GOAL_SUPPORT_HELP_YOU: '讓我們幫助你',
            AXA_GOAL_SUPPORT_HELP: '尚有疑問？可從以下途徑尋求協助。',
            AXA_GOAL_SUPPORT_HELP_TEXT:
              '聯絡您的理財顧問，或我們的客戶服務部。',
            AXA_GOAL_SUPPORT_CONTACT_AGENT: '聯絡理財顧問',

            // AXA Goal record
            AXA_GOAL_RECORD_TITLE: '步行紀錄',
            AXA_GOAL_RECORD_PROBLEM: '對達標日數有疑問？',
            AXA_GOAL_RECORD_SUPPORT: '支援',
            AXA_GOAL_RECORD_ACHIEVED_DAY: '達標日（10,000+ 步)',
            AXA_GOAL_RECORD_NON_ACHIEVED_DAY: '非達標日（低於 10,000 步）',
            SH_AXA_GOAL_RECORD_ACHIEVED_DAY: '達標日（10,000+ 步）',
            SH_AXA_GOAL_RECORD_NON_ACHIEVED_DAY: '非達標日（低於 10,000 步）',
            AXA_GOAL_RECORD_DATA_PROCESSING_DAY:
              '數據處理中（將於 48 小時內完成）',
            AXA_GOAL_RECORD_START_DAY: '會藉年度開始日',
            AXA_GOAL_RECORD_END_DAY: '會藉年度完結日',
            AXA_GOAL_RECORD_START: '開始',
            AXA_GOAL_RECORD_END: '完結',
            AXA_GOAL_RECORD_HEAD_TITLE: '達標日數',

            //CountryTelephoneNumber
            COUNTRY_TELEPHONE_NUMBER_DROPDOWN_PLACEHOLDER: '選擇',

            //aktivo-health-survey
            AKTIVO_HEALTH_SURVEY_TITLE: '健康問卷',
            AKTIVO_HEALTH_SURVEY_HOME_TITLE: '設置您的健康檔案',
            AKTIVO_HEALTH_SURVEY_HOME_CONTENT:
              '告訴我們多一點，讓我們為您提供更多個人化的健康建議',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_TITLE: '我們需要以下的資料：',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_GENDER: '性別',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_DOB: '出生日期',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_HEIGHT: '身高',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_WEIGHT: '體重',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_SLEEP: '睡眠模式',
            AKTIVO_HEALTH_SURVEY_HOME_INFO_DAILY: '生活習慣',
            AKTIVO_HEALTH_SURVEY_GENDER_TITLE: '您的性別',
            AKTIVO_HEALTH_SURVEY_GENDER_MALE: '男性',
            AKTIVO_HEALTH_SURVEY_GENDER_FEMALE: '女性',
            AKTIVO_HEALTH_SURVEY_DOB_TITLE: '您的出生日期',
            AKTIVO_HEALTH_SURVEY_DOB: '出生日期',
            AKTIVO_HEALTH_SURVEY_TALL_TITLE: '您的身高',
            AKTIVO_HEALTH_SURVEY_WEIGHT_TITLE: '您的體重',
            AKTIVO_HEALTH_SURVEY_SLEEPING_TITLE: '您的睡眠模式',
            AKTIVO_HEALTH_SURVEY_SMOKE_TITLE: '您的吸煙習慣',
            AKTIVO_HEALTH_SURVEY_DRINK_TITLE: '您的喝酒習慣',
            AKTIVO_HEALTH_SURVEY_CONTINUE: '下一題',
            AKTIVO_HEALTH_SURVEY_FINISH_THE_SURVEY: '提交問卷',
            AKTIVO_HEALTH_SURVEY_LAUNCH_MY_WELLNESS: '開始',
            AKTIVO_HEALTH_SURVEY_END_THANK_YOU: '問卷已完成',
            AKTIVO_HEALTH_SURVEY_END_TEXT_1:
              '我們將根據您的問卷回覆提供個人化的健康資訊。',
            AKTIVO_HEALTH_SURVEY_END_TEXT_2:
              '開始使用健康拍檔，建立更健康的人生吧！',
            AKTIVO_HEALTH_SURVEY_BED_TIME: '就寢時間',
            AKTIVO_HEALTH_SURVEY_WAKE_UP_TIME: '起床時間',
            AKTIVO_HEALTH_SURVEY_SMOKE_QUESTION: '您平均每日吸食多少支香煙？',
            AKTIVO_HEALTH_SURVEY_DRINK_QUESTION: '您平均一週喝多少杯酒？',
            AKTIVO_HEALTH_SURVEY_PREFER_NOT_TO_ANSWER: '不願透露',
            AKTIVO_HEALTH_SURVEY_LBS: '磅',
            AKTIVO_HEALTH_SURVEY_KG: '公斤',
            AKTIVO_HEALTH_SURVEY_CM: '厘米',

            //dropdown common title
            DROPDOWN_COMMON_TITLE: '選擇',

            // enter password
            ENTERPASSWORD_NAV_TITLE: '刪除帳戶',
            ENTERPASSWORD_TITLE: '抱歉您選擇',
            ENTERPASSWORD_SUB_TITLE:
              '刪除您的 Emma by AXA 賬戶，在您繼續下一步前，請留意：',
            ENTERPASSWORD_SUB_DESC:
              '1.若我們或第三方的系統存有下列與您相關的資料，這些資料將不會隨您的賬戶一起被刪除，但您亦無法繼續透過 Emma 進行存取。這些資料將根據${pics}進行保留及處理。',
            ENTERPASSWORD_SUB_DESC_PICS: '個人資料收集聲明 ',
            ENTERPASSWORD_SECTION_ONE:
              'AXA Goal 步行數據紀錄 – 將會儲存於我們的資料庫以供計算您的保費回贈，直至您的所有 AXA Goal 合資格保單失效後 7 年',
            ENTERPASSWORD_SECTION_TWO: '健康拍檔/My Wellness 健康挑戰紀錄',
            ENTERPASSWORD_SECTION_THREE:
              'Dr Go 付費服務 – 將會儲存於益體健有限公司 的資料庫以供您繼續使用此等服務，直至您的服務失效後 7 年',
            ENTERPASSWORD_DESC_ONE:
              '2.若您選購了Dr Go的付費服務，您將不能再透過 Emma 繼續使用，請以您的相關 Dr Go 賬戶登入 Dr Go 手機應用程式或網頁以繼續使用這些服務。',
            ENTERPASSWORD_DESC_TWO:
              '3.您可在成功刪除 Emma by AXA 賬戶 24 小時後，重新以現有的用戶名稱註冊新賬戶。若您是 AXA Goal 用戶，只有刪除現有賬戶前或註冊新賬戶後的步行數據（以較高者為準）會被用作計算保費回贈之用。',
            ENTERPASSWORD_DESC_THREE: '若需協助，請致電我們的的客戶服務熱線',
            ENTERPASSWORD_DESC_THREE_TEL: '(852) 2802 2812.',
            ENTERPASSWORD_NEXT_BUTTON: '確認刪除',
            ENTERPASSWORD_CONFIRMATION_TITLE: '很遺憾看見您離開！',
            ENTERPASSWORD_CONFIRMATION_SUB_TITLE: '希望我們能再次為您服務！',
            ENTERPASSWORD_CONFIRMATION_STEP_ONE_TITLE: '再見',
            ENTERPASSWORD_CONFIRMATION_STEP_TWO_TITLE:
              '您可以在幾天後重新使用您的用戶名稱以創建另一個新帳戶。',
            ENTERPASSWORD_CONFIRMATION_LOGOUT: '登出',
            // aktivo individual challenge
            AKTIVO_INDIVIDUAL_CHALLENGE_APPLY: '確認',
            AKTIVO_INDIVIDUAL_CHALLENGE_FILTER: '選項',
            AKTIVO_INDIVIDUAL_CHALLENGE_SORTING: '排序',
            AKTIVO_INDIVIDUAL_CHALLENGE_CATEGORY: '類別',
            AKTIVO_INDIVIDUAL_CHALLENGE_CHALLENGE_TYPE: '挑戰',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_PERIOD: '新舊',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_LATEST_TO_OLDEST: '新至舊',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_OLDEST_TO_LATEST: '舊至新',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_START_MOVING_TODAY: '立即開始',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_LEARN_MORE: '了解更多',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_ONGOING: '進行中',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_READY_TO_ENROLL: '可參加',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_OVER: '已完結',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_YOUR_PROGRESS: '你的進度',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_STEPS: '步',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_COMPLETED: '完成',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_COMING_SOON: '即將開始',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_CHALLENGE_DETAILS: '挑戰詳情',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_ENROLL_NOW: '立即參加',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_COMPLETED_CHALLENGE: '已完結',
            AKTIVO_INDIVIDUAL_CHALLENGE_TIME_CHALLENGE_TITLE: '我的挑戰',
            AKTIVO_INDIVIDUAL_CHALLENGE_HEALTH_INSIGHTS_TITLE: '健康分析',
            AKTIVO_INDIVIDUAL_CHALLENGE_HEALTH_INSIGHTS_ERROR_MSG_TITLE_PART1:
              '同步失敗，請檢查網絡連接狀態並',
            AKTIVO_INDIVIDUAL_CHALLENGE_HEALTH_INSIGHTS_ERROR_MSG_TITLE_PART2:
              '[重新載入]。',
            AKTIVO_INDIVIDUAL_CHALLENGE_HEALTH_INSIGHTS_OUR_SUGGESTION_TITLE:
              '健康建議',
            AKTIVO_INDIVIDUAL_CHALLENGE_ALL_ENROLLED_TITLE: '做得好！',
            AKTIVO_INDIVIDUAL_CHALLENGE_ALL_ENROLLED_SUB_TITLE:
              '現在沒有可參加的新挑戰',
            AKTIVO_INDIVIDUAL_CHALLENGE_ALL_NO_ENROLLED_TIP: '步行',
            AKTIVO_INDIVIDUAL_CHALLENGE_ALL_NO_ENROLLED_TITLE:
              '挑戰一週步行100,000步',
            AKTIVO_INDIVIDUAL_CHALLENGE_ALL_NO_ENROLLED_SUB_TITLE:
              '您尚未參加任何挑戰或進行中的挑戰尚未完結',
            AKTIVO_INDIVIDUAL_CHALLENGE_ALL_NO_ENROLLED_BUTTON: '立即參加',
            AKTIVO_INDIVIDUAL_CHALLENGE_START: '開始',
            LOGIN_PRIVACY_POLICY: '私隱政策',
            LOGIN_TERMS_AND_CONDITIONS: '條款及細則',
            LOGIN_PRIVACY_AND: '及',
          },
        },
      },
      lng: getLanguage(),
      fallbackLng: 'en',
      debug: true,
      ns: ['translations'],
      defaultNS: 'translations',
      keySeparator: false, // we use content as keys
      interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ',',
      },
      react: {
        wait: true,
      },
    })
    .then((i18nextT) => {
      t = i18nextT;
      return Promise.resolve();
    });
export { t };
